export default {
  'transaction.created_at': 'Thời gian giao dịch',
  'transaction.amount': 'Tiền giao dịch',
  'transaction.action': 'Hành động',
  'global.fullname': 'Họ và tên',
  'global.doctorlist': 'Danh sách nhân viên',
  'global.document': 'Tài liệu',
  'global.document_alert':
    'Không thể xem file khác định dạng ảnh. Hãy thử download',
  'global.count_order': 'Số lượng đơn hàng',
  'global.avatar': 'Ảnh',
  'global.select_language': 'Chọn ngôn ngữ',
  'global.address': 'Địa chỉ',
  'global.earning_pending': 'Đang chờ rút',
  'global.transaction_pending': 'Đang chờ xác nhận',
  'global.transaction_approved': 'Đã xác nhận',
  'global.transaction_declined': 'Bị từ chối',
  'global.earning_available': 'Chưa rút',
  'global.earning_paid': 'Đã rút',
  'global.count_image': 'Số lượng ảnh',
  'global.discount': 'Chiết khấu',
  'global.earned': 'Thu về',
  'global.setup_calendar': 'Quản lý giá',
  'global.property_title': 'Tên căn hộ',
  'global.order_number': 'Mã đơn hàng',
  'global.order_pending_confirm': 'Chờ xác nhận',
  'global.customer_info': 'Người đặt',
  'global.order_cancel_pending': 'Xử lý hủy',
  'global.detail_order': 'Chi tiết đơn hàng',
  'global.detail_customer': 'Thông tin người đặt',
  'global.phone': 'Điện thoại',
  'global.email_invalid': 'Email không hợp lệ',
  'global.phone_invalid': 'Số điện thoại không hợp lệ',
  'global.phone_min_length': 'Số điện thoại phải có ít nhất 10 chữ số',
  'global.phone_max_length': 'Số điện thoại phải có nhiều nhất 15 chữ số',
  'global.email_required': 'Yêu cầu điền email',
  'global.phone_required': 'Yêu cầu điền số điện thoại',
  'global.order_reject': 'Từ chối',
  'global.order_cancel': ' Đã hủy',
  'global.order_complete': 'Đã hoàn thành',
  'global.order_expire': 'Hết hạn',
  'global.order_confirm': 'Đã xác nhận',
  'global.total': 'Tổng tiền',
  'global.depart': 'Ngày đến',
  'global.return_date': 'Ngày đi',
  'global.adults': 'Số người',
  'global.full_name': 'Họ tên',
  'global.created': 'Ngày tạo',
  'global.setup': 'Cài đặt',
  'global.setup_calender': 'Quản lý giá',
  'global.role': 'Vai trò',
  'global.add': 'Thêm mới',
  'global.edit': 'Sửa',
  'global.password': 'Mật khẩu',
  'global.admin': 'Quản trị viên',
  'global.staff': 'Nhân viên',
  'global.gender': 'Giới tính',
  'global.date_of_bird': 'Ngày sinh',
  'global.identity': 'CMT/CCCD',
  'global.nam': 'Nam',
  'global.bills': 'Thu chi',
  'global.nu': 'Nữ',
  'global.ngay_cap': 'Ngày cấp',
  'global.noi_cap': 'Nơi cấp',
  'global.so_bhyt': 'Số BHYT',
  'widgets.recentNotifications': 'Thông báo gần đây',
  'button.viewAll': 'Xem tất cả',
  'widgets.recentMessage': 'Tin nhắn gần đây',
  'global.user': 'Người dùng',
  'global.status': 'Trạng thái',
  'global.add_new': 'Thêm mới',
  'global.published': 'Hiển thị',
  'global.unpublished': 'Ẩn',
  'global.delete': 'Xóa',
  'global.clear_deleted': 'Ẩn tài khoản đã xóa',
  'global.clear_deleted_confirm':
    'Ẩn tất cả tài khoản đã xóa (deleted-user-*) khỏi danh sách admin? Thao tác này set deleted_at cho các tài khoản đó.',
  'global.clear_deleted_result': 'Đã ẩn {count} tài khoản đã xóa',
  'global.delete_confirm': 'Bạn có chắc chắn muốn xóa bản ghi này không?',
  'global.create': 'Tạo',
  'global.update': 'Cập nhật',
  'global.image': 'Ảnh',
  'global.title': 'Tiêu đề',
  'global.company': 'Công ty',
  'global.id': 'ID',
  'global.tabbasic': 'Thông tin cơ bản',
  'global.alias': 'Bí danh',
  'global.desc': 'Mô tả',
  'global.cancel': 'Hủy',
  'global.active': 'Hiển thị',
  'global.inactive': 'Ẩn',
  'global.deactivate': 'Hủy kích hoạt',
  'global.submit': 'Gửi',
  'global.trashed': 'Đã xóa',
  'global.approved': 'Phê duyệt',
  'global.from': 'Điểm đi',
  'global.to': 'Điểm đến',
  'global.price': 'Giá',
  'global.duration_months': 'Thời hạn (Tháng)',
  'global.please_input_price': 'Vui lòng nhập giá',
  'global.please_input_duration_months': 'Vui lòng nhập thời hạn (tháng)',
  'global.car': 'Xe hơi',
  'global.type': 'Loại',
  'global.cancel_policy': 'Chính sách',
  'global.instant_bookable': 'Có thể đặt ngay',
  'global.yes': 'Có',
  'global.no': 'Không',
  'global.city': 'Thành phố',
  'global.street': 'Đường phố',
  'global.location': 'Vị trí',
  'global.choose-location': 'Chọn vị trí',
  'global.square_feet': 'Diện tích',
  'global.cover_img': 'Ảnh bìa',
  'global.gallery': 'Ảnh chỗ nghỉ',
  'global.security_deposit': 'Tiền đặt cọc',
  'global.minimum_nights': 'Số đêm tối thiểu',
  'global.cleaning_fee': 'Phí dọn dẹp',
  'global.maximum_nights': 'Số đêm tối đa',
  'global.months': 'Tháng',
  'global.ward': 'Xã/Phường',
  'global.nearbyUtils': 'Tiện ích xung quanh',
  'global.back': 'Trở về',
  'global.next': 'Tiếp theo',
  'global.required': 'Bắt buộc',
  'global.default_option': 'Chọn một option',
  'global.province': 'Tỉnh/Thành phố',
  'global.district': 'Quận/Huyện',
  'global.no_house': 'Số nhà',
  'global.extra_price': 'Giá tăng thêm',
  'global.accommodation': 'Chỗ nghỉ',
  'global.dashboard': 'Trang chủ',
  'global.reservations': 'Đặt chỗ',
  'global.chat': 'Tin nhắn',
  'global.conversation': 'Hội thoại',
  'global.calendar': 'Lịch đặt chỗ',
  'global.earning': 'Doanh thu',
  'global.firstname': 'Tên',
  'global.lastname': 'Họ và đệm',
  'global.email': 'Email',
  'global.detail_property': 'Thông tin căn hộ',
  'global.mobile': 'Điện thoại',
  'global.birthday': 'Ngày sinh',
  'global.id_name': 'Họ tên đầy đủ',
  'global.id_number': 'Số CMND/Căn cước',
  'global.id_create': 'Ngày cấp',
  'global.id_image': 'Ảnh CMND/Căn cước',
  'global.property': 'Chỗ nghỉ',
  'global.create_bank': 'Thêm tài khoản ngân hàng',
  'global.name_bank': 'Ngân hàng',
  'global.branch': 'Chi nhánh',
  'global.account_name': 'Tên tài khoản',
  'global.account_number': 'Số tài khoản',
  'global.notes': 'Ghi chú',
  'global.note': 'Ghi chú',
  'global.budget': 'Ngân sách',
  'global.please_enter_valid_budget': 'Vui lòng nhập ngân sách hợp lệ',
  'global.min_budget': 'Ngân sách tối thiểu',
  'global.max_budget': 'Ngân sách tối đa',
  'global.please_enter_valid_min_budget':
    'Vui lòng nhập ngân sách tối thiểu hợp lệ',
  'global.please_enter_valid_max_budget':
    'Vui lòng nhập ngân sách tối đa hợp lệ',
  'global.min_budget_must_be_lte_max_budget':
    'Ngân sách tối thiểu không được lớn hơn ngân sách tối đa',
  'global.note_by': 'Ghi chú bởi',
  'global.note_placeholder': 'Thêm ghi chú...',
  'global.day': 'Ngày',
  'global.last_30_day': '30 ngày gần nhất',
  'global.last_7_day': '7 ngày gần nhất',
  'global.last_month': 'Tháng trước',
  'global.this_month': 'Tháng này',

  'global.service_orgin': 'Xuất xứ',
  'global.service_clientCode': 'Mã Khách Hàng',

  'global.status_pending': 'Chờ xác nhận',
  'global.status_activated': 'Đã xác nhận',
  'global.status_rejected': 'Đã từ chối',

  'global.action': 'Hành động',
  'global.preview': 'Xem trước',
  'global.view_more': 'Xem thêm',
  'global.selected_items': 'Đang chọn {count} bản ghi',
  'global.ownership_document': 'Tài liệu',

  'sidebar.amenity': 'Lễ nghi',
  'sidebar.bills': 'Thu chi',
  'sidebar.services': 'Dịch vụ',

  'sidebar.doctors': 'Nhân viên',
  'sidebar.inbox': 'Tin nhắn',
  'sidebar.conversation': 'Cuộc hội thoại',
  'sidebar.reservations': 'Đặt chỗ',
  'sidebar.earning': 'Doanh thu',
  'sidebar.calendar': 'Lịch',
  'sidebar.promotion': 'Khuyến mại',
  'sidebar.promotionDetail': 'Chi tiết khuyến mại',
  'sidebar.reports': 'Báo cáo',
  'sidebar.orders': 'Đặt Lab',

  'global.working_day_price': 'Trong tuần',
  'global.weekend_price': 'Cuối tuần',
  'global.description': 'Mô tả',
  'global.save': 'Lưu',
  'global.actions': 'Hành động',

  'doctor.list': 'Danh sách bác sĩ và nhân viên',
  'promotion.start_date': 'Áp dụng từ',
  'promotion.end_date': 'Đến',
  'promotion.start_buy_date': 'Khi mua từ',
  'promotion.end_buy_date': 'Đến',
  'promotion.style': 'Kiểu',
  'promotion.amount': 'Giá trị',
  'promotion.information': 'Thông tin chung',
  'promotion.items': 'Danh sách items',
  'promotion.choose_product': 'Chọn loại',
  'promotion.choose_item': 'Chọn item',
  'global.transport': 'Di chuyển',
  'promotion.percent': 'Phần trăm',
  'promotion.fixed_number': 'Cố định',
  'promotion.normal': 'Thông thường',
  'promotion.addition_of_admin': 'Thêm bởi admin',
  'promotion.edit': 'Sửa khuyến mãi',
  'promotion.create': 'Thêm khuyến mãi',
  'global.male': 'Nam',
  'global.female': 'Nữ',
  'global.date': 'Ngày',
  'global.hour': 'Giờ',
  'global.free': 'Miễn phí',
  'global.detail': 'Chi tiết',
  'route.duration': 'Thời gian dự kiến',
  'route.free_waiting_time': 'Thời gian miễn phí chờ',
  'route.cancel_hour_policy': 'Huỷ miễn phí nếu huỷ ... trước giờ đón',
  'global.route_add': 'Tạo tuyến đường',
  // "global.customer_info": "Người đặt",
  'global.select_customer': 'Chọn một công ty',
  'global.select_vehicle': 'Chọn phương tiện',
  'global.input_title': 'Nhập tiêu đề',
  'global.select_airport': 'Chọn sân bay',
  'global.select_city': 'Chọn tỉnh/thành phố',
  'global.select_district': 'Chọn quận/huyện',
  'global.type_desc': 'Nhập mô tả',
  'route.success': 'Thành công',
  'route.create_success':
    'Tạo tuyến đường thành công. Bạn có muốn tiếp tục tạo tuyến đường khác?',
  'route.continue': 'Tiếp tục tạo',
  'route.goto_list': 'Quay lại danh sách',
  'global.route_detail': 'Chi tiết tuyến đường',
  'global.min': 'Phút',
  'global.terms&Conditions': 'Điều khoản và điều kiện',
  'global.$': 'VNĐ',
  'global.airport': 'Sân bay',
  'global.patients': 'Bệnh nhân',
  'global.setting': 'Cài đặt',
  'global.appointments': 'Lịch hẹn',
  'global.suppliers': 'Nhà cung cấp',
  'global.supplier': 'Nhà cung cấp',
  // "global.id_number": "TT",
  'global.code': 'Mã số',
  'global.clinic': 'Phòng khám',
  'global.website': 'Website',
  'global.contact_name': 'Tên liên hệ',

  'global.doctor': 'Bác sĩ',
  'global.service': 'Dịch vụ',
  'global.amount': 'Phí',
  'global.services': 'Dịch vụ',
  'global.datetime': 'Ngày giờ',
  'global.treatment': 'Thủ thuật',
  'global.select_service': 'Chọn dịch vụ',
  'global.select_doctor': 'Chọn bác sĩ',
  'global.assistant': 'Chọn trợ lý',
  'global.treated_at': 'Thời gian',
  'global.warranty': 'Bảo hành',
  'global.name': 'Tên',
  'global.signin': 'Đăng nhập',
  'global.registration_header': 'Đăng ký tài khoản',
  'signup.send_activation_success': 'Gửi email kích hoạt thành công',
  'signup.activation_guide':
    'Bạn hãy kiểm tra hòm thư hoặc trong mục thư rác của bạn và làm theo hướng dẫn để kích hoạt tài khoản',
  'signup.back_to_login': 'Quay lại trang đăng nhập',
  'global.signup': 'Đăng ký tài khoản',
  'global.is_warrantable': 'Có bảo hành',
  'global.supplies_price': 'Giá vật tư',
  // "global.patients": "Bệnh nhân",
  'global.forgot_password': 'Quên mật khẩu',
  'global.emai_required': 'Yêu cầu điền email',
  'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email không đúng định dạng',
  'global.confirm_password': 'Xác nhận mật khẩu',
  'global.changepassword': 'Đổi mật khẩu',
  'global.confirm_new_password': 'Xác nhận mật khẩu mới',
  'global.new_password': 'Mật khẩu mới',
  'global.current_password': 'Mật khẩu hiện tại',
  'global.password_not_match': 'Mật khẩu không khớp',
  'global.password_min_charactor': 'Độ dài mật khẩu tối thiểu 6 ký tự',
  'global.continue': 'Tiếp tục',
  'global.country': 'Quốc gia',
  'global.clinic_name': 'Tên phòng khám',
  'global.signout': 'Thoát',
  'global.email_reset_password': 'Điền email của bạn',
  'global.recover_password': 'Lấy lại mật khẩu',
  'global.search_placeholder': 'Gõ để tìm kiếm',
  'global.requiredfield': 'Bắt buộc điền dữ liệu',
  'global.deleted_success': 'Xóa dữ liệu thành công',
  'global.accept_agreement_warning':
    'Bạn phải đồng ý với các điều khoản để tiếp tục',
  'global.language': 'Ngôn ngữ',
  'global.currency': 'Tiền tệ',
  'global.save_success': 'Lưu thành công',
  'global.save_failed': 'Có lỗi xảy ra',
  'global.payment': 'Thanh toán',
  'global.orders': 'Đặt hàng',
  'global.patient': 'Bệnh nhân',
  'global.timezone': 'Múi giờ',
  'appointment.scheduled_date': 'Thời gian hẹn',
  'appointment.create': 'Tạo lịch hẹn',
  'appointment.status_confirmed': 'Xác nhận',
  'appointment.status_checkedin': 'Đã đến',
  'appointment.status_noshow': 'Không đến',
  'appointment.status_cancelled': 'Đã hủy',
  'global.payment_method': 'Phương thức thanh toán',
  'global.method': 'Phương thức',
  'global.cash': 'Tiền mặt',
  'global.card': 'Thẻ',
  'global.bank': 'Chuyển khoản',
  'global.insurance': 'Bảo hiểm',
  'bill.billed_date': 'Ngày',
  'bill.serial': 'Mã',
  'bill.amount': 'Số tiền',
  'bill.total_amount': 'Tổng số tiền: ',
  'bill.total_cases': 'Tổng số ca: ',
  'global.data_initialization': 'Chúng tôi đang khởi tạo dữ liệu cho bạn !',

  'global.unit': 'Đơn vị',
  'unit.item': 'Chiếc',
  'unit.teeth': 'Răng',
  'unit.tooth': 'Hàm',
  'unit.time': 'Lần',
  'global.account_information': 'Thông tin tài khoản',
  'global.upgrade': 'Nâng cấp',
  'global.your_plan': 'Loại tài khoản',
  'global.trial_end': 'Ngày hết hạn',
  'global.license': 'Giấy phép',
  'global.telephone': 'Điện thoại',
  'clinic.alias': 'Tên viết tắt',
  'global.duration': 'Thời gian làm',
  'global.select_patient': 'Chọn bệnh nhân',
  'global.select_supplier': 'Chọn nhà cung cấp',
  'order.delivery_at': 'Ngày giao',
  'order.sample_at': 'Ngày nhận mẫu',
  'order.ordered_at': 'Ngày đặt',
  'global.qty': 'Số lượng',
  'global.total_qty': 'Tổng số lượng:',
  'global.story': 'Tiền sử bệnh',
  'global.field_bloodpressure': 'Huyết áp',
  'global.field_bpm': 'Nhịp tim',
  'global.field_spo2': 'Spo2',
  'global.field_height': 'Cao',
  'global.field_weight': 'Cân nặng',
  'global.add_supplier': 'Thêm nhà cung cấp',
  'global.paid': 'Đã TT',
  'global.notpaid': 'Chưa TT',
  'global.category': 'Nhóm',
  'global.select_category': 'Chọn nhóm',
  'group.xray': 'X Quang',
  'group.whitening': 'Làm trắng',
  'group.implant': 'Implant',
  'group.hygiene': 'Vệ sinh',
  'group.rootcanal': 'Điều trị tủy',
  'group.surgery': 'Phẫu thuật',
  'group.prosthetic': 'Răng giả',
  'group.consultation': 'Khám và tư vấn',

  'global.categories': 'Thể loại',
  'global.propertytypes': 'Khách sạn',
  'global.app_id': 'Mã ứng dụng',
  'global.body': 'Nội dung',

  'global.role_management': 'Quản lý vai trò',
  'global.role_name': 'Tên vai trò',
  'global.role_description': 'Mô tả',
  'global.role_key': 'Mã vai trò',

  // faq
  'global.faq': 'Hỏi đáp',
  'global.question': 'Câu hỏi',
  'global.answer': 'Trả lời',

  'global.app-all': 'Ứng dụng',
  'global.config': 'Cấu hình',
  'global.pending': 'Đang chờ',
  'global.activated': 'Đã kích hoạt',
  'global.blocked': 'Đã chặn',
  'global.resetpassword': 'Đặt lại mật khẩu',
  'global.input_password': 'Nhập mật khẩu',
  'global.is_verified_email': 'Xác thực email',
  'global.is_mobile_verified': 'Xác thực số điện thoại',
  'global.unverified': 'Chưa xác thực',
  'global.verified': 'Đã xác thực',
  'global.role_apps': 'Vai trò ứng dụng',
  'global.network': 'Mạng',
  'global.shop': 'Cửa hàng',
  'global.bio': 'Tiểu sử',
  'global.delete_success': 'Xóa thành công!',
  'global.copy': 'Sao chép',
  'global.image_alt': 'Hình ảnh thay thế',
  'global.schema_type': 'Loại schema',
  'global.slug': 'Đường dẫn',
  'global.sub_title': 'Tiêu đề phụ',
  'global.price_discount': 'Giá giảm',
  'global.price_roundtrip': 'Giá khứ hồi',
  'global.infant_price': 'Giá trẻ em',
  'global.rating': 'Đánh giá',
  'global.room_rate': 'Giá phòng',
  'global.neighbourhood_cleansed': 'Khu vực đã làm sạch',
  'global.neighbourhood_group_cleansed': 'Nhóm khu vực đã làm sạch',
  'global.bedrooms': 'Phòng ngủ',
  'global.bathrooms': 'Phòng tắm',
  'global.beds': 'Giường',
  'global.bed_type': 'Loại giường',
  'global.gallerySetting': 'Cài đặt thư viện',
  'global.guests_included': 'Số khách bao gồm',
  'global.extra_people': 'Khách thêm',
  'global.refresh': 'Làm mới',
  'global.distance': 'Khoảng cách',
  'car.driver': 'Tài xế',
  'car.seat': 'Ghế',
  'car.luggage': 'Hành lý',
  'car.ordering': 'Đặt xe',
  'car.facility': 'Tiện nghi',
  'car.air_machine': 'Điều hòa',
  'car.energy_saving': 'Tiết kiệm năng lượng',
  'car.stop_point': 'Điểm dừng',
  'property.start_date': 'Ngày bắt đầu',
  'property.end_date': 'Ngày kết thúc',
  'property.price_week': 'Giá theo tuần',
  'property.weekend_price': 'Giá cuối tuần',
  'property.extra_price': 'Giá thêm',
  'property.host_languages': 'Ngôn ngữ chủ nhà',
  'property.week_term_promo': 'Khuyến mãi theo tuần',
  'property.month_term_promo': 'Khuyến mãi theo tháng',
  'property.price_weekend': 'Giá cuối tuần',
  'global.guests_standard': 'Số khách tiêu chuẩn',
  'global.guests_max': 'Số khách tối đa',
  'sidebar.transport': 'Vận chuyển',
  'sidebar.amenity': 'Tiện ích',
  'sidebar.restaurant': 'Nhà hàng',
  'sidebar.property': 'Bất động sản',
  'sidebar.property_type': 'Loại bất động sản',
  'sidebar.room': 'Phòng',
  'sidebar.cancel_policy': 'Chính sách hủy',
  'sidebar.vehicle': 'Phương tiện',
  'sidebar.car': 'Xe',
  'sidebar.route': 'Tuyến đường',
  'sidebar.routes': 'Các tuyến đường',
  'sidebar.inbox': 'Hộp thư đến',
  'sidebar.conversation': 'Hội thoại',
  'sidebar.reservations': 'Đặt chỗ',
  'sidebar.earning': 'Doanh thu',
  'sidebar.calendar': 'Lịch',
  'sidebar.reports': 'Báo cáo',
  'sidebar.services': 'Dịch vụ',
  'sidebar.addons_order': 'Dịch vụ bổ sung',
  'sidebar.debt_confirmation_record': 'Biên bản xác nhận nợ',
  'global.requiredfield': 'Trường bắt buộc',
  'property.room_type': 'Loại phòng',
  'global.propertytypes': 'Loại bất động sản',
  'global.save': 'Lưu',
  'global.save_and_close': 'Lưu & đóng',
  'global.signin': 'Đăng nhập',
  'global.signup': 'Đăng ký',
  'global.forgot_password': 'Quên mật khẩu',
  'global.search_placeholder': 'Tìm kiếm',
  // Tour
  'global.duration': 'Thời lượng',
  'global.routes': 'Các tuyến đường',
  'global.category': 'Danh mục',
  'global.cover_image': 'Ảnh bìa',
  'global.url': 'Đường dẫn ảnh',
  'global.operator': 'Nhà điều hành',
  'global.from_price': 'Giá từ',
  'global.itinerary': 'Lịch trình',
  'global.itineraries': 'Các lịch trình',
  'global.updated_at': 'Cập nhật lúc',
  'global.last_login_at': 'Đăng nhập lần cuối',
  'global.from_priceMGMT': 'Quản lý giá',
  'global.from_price_setting': 'Cài đặt giá',
  'global.tours': 'Tour',
  'global.tour_id': 'Mã tour',
  'global.transportation': 'Phương tiện di chuyển',
  'global.score': 'Điểm số',
  'global.tour_option': 'Tùy chọn tour',
  'global.hourly': 'Theo giờ',
  'tour.title': 'Tiêu đề',
  'tour.private_tour': 'Tour riêng',
  'tour.start_time_required': 'Yêu cầu thời gian bắt đầu hoặc đón?',
  'global.select_category': 'Chọn danh mục',
  'global.select_operator': 'Chọn nhà điều hành',
  'global.select_cabin_type': 'Chọn loại cabin',
  'tour.description': 'Mô tả tour',
  'tour.inclusion': 'Bao gồm',
  'tour.exclusion': 'Không bao gồm',
  'global.inactive': 'Không hoạt động',
  'global.meal': 'Bữa ăn',
  'global.category_operator': 'Danh mục & nhà điều hành',
  'tour.pricing': 'Mô hình giá',
  'tour.special': 'Đặc biệt',
  'tour.normal': 'Bình thường',
  'tour.featured': 'Nổi bật',
  'tour.time_mgmt': 'Quản lý thời gian',
  'tour.duration_unit': 'Đơn vị thời lượng',
  'tour.duration': 'Thời lượng',
  'tour.start_time': 'Thời gian bắt đầu',
  'tour.instant_confirm': 'Xác nhận ngay',
  'global.delete_confirm': 'Bạn có chắc chắn muốn xóa mục này?',
  'global.cancel_order': 'Bạn có chắc chắn muốn hủy mục này?',
  'tour.gallery': 'Thư viện ảnh',
  'global.ticket': 'Vé',
  'global.min_person': 'Số người tối thiểu',
  'global.freeCancelHours': 'Giờ hủy miễn phí',
  'global.freeCancel': 'Hủy miễn phí',
  'tour.freeCancel': 'Hủy miễn phí',
  'global.cancelPolicy': 'Chính sách hủy',
  'global.meeting': 'Điểm gặp mặt',
  'global.meetingPoint': 'Điểm gặp mặt',
  'global.meeting_point': 'Điểm gặp mặt',
  'global.meeting_point_type': 'Loại điểm gặp mặt',
  'global.meetingPointNotes': 'Ghi chú điểm gặp mặt',
  'tour.cutOffTime': 'Thời gian chốt (giờ)',
  'tooltip.cutOffTime': 'VD: 2 ngày trước ngày khởi hành là 48 giờ',
  'global.perPerson': 'Theo người',
  'global.perGroup': 'Theo nhóm',
  'global.optionTitle': 'Tiêu đề tùy chọn',
  'global.checkall': 'Chọn tất cả',
  // Option
  'global.max_person': 'Số người tối đa',
  'global.max': 'Tối đa',
  'global.adult_price': 'Giá người lớn',
  'global.child_price': 'Giá trẻ em',
  'global.cost_price': 'Giá gốc',
  'global.cost': 'Chi phí',
  'global.selling_price': 'Giá bán',
  'global.selling': 'Bán',
  'global.cost_price_notes': 'Ghi chú giá gốc',
  'global.select_tour': 'Chọn tour',
  'global.option': 'Tùy chọn',
  'global.options': 'Các tùy chọn',
  'option.group': 'Nhóm',
  'global.Vehicle_type': 'Loại xe',
  'global.timeStart': 'Thời gian bắt đầu',
  'global.startWorkingTime': 'Thời gian bắt đầu làm việc',
  '.endWorkingTime': 'Thời gian kết thúc làm việc',

  'global.tour_type': 'Loại tour',

  // Destination
  'global.destination': 'Điểm đến',
  'global.select_destination': 'Chọn điểm đến',
  'global.countries': 'Quốc gia',
  'global.select_country': 'Chọn quốc gia',
  'destination.longitude': 'Kinh độ',
  'destination.latitude': 'Vĩ độ',
  'global.destination_parent': 'Điểm đến cha',

  // Categories
  'global.categories': 'Danh mục',

  // Operators
  'global.operators': 'Nhà điều hành',
  'global.firstname': 'Tên',
  'global.lastname': 'Họ',
  'global.email': 'Email',
  'global.phone': 'Số điện thoại',
  'global.hotline': 'Đường dây nóng',

  // Currencies
  'global.currencies': 'Tiền tệ',
  'currency.name': 'Tên',
  'currency.display': 'Hiển thị',
  'currency.exchange_rate': 'Tỷ giá',
  'currency.thousand': 'Định dạng',
  'currency.image': 'Biểu tượng',
  'currency.symbol': 'Ký hiệu',
  'currency.exchange_rate_help': "Số đơn vị tiền này trên 1 USD. Sửa tay sẽ được ghi vào lịch sử; khoá tỷ giá để đợt sync tự động không ghi đè.",
  'currency.rate_locked': "Khoá tỷ giá",
  'currency.rate_locked_help': "Tỷ giá đã khoá sẽ được bỏ qua khi sync tự động (6 giờ/lần).",
  'currency.decimals': "Số thập phân",
  'currency.decimals_help': "Số chữ số thập phân hiển thị trên site (0 cho VND, JPY, KRW, IDR).",
  'currency.no_rate': "Chưa có tỷ giá",
  'currency.rate_source': "Nguồn tỷ giá",
  'currency.history': "Lịch sử tỷ giá",
  'currency.history_title': "Lịch sử tỷ giá · {code}",
  'currency.history_time': "Thời gian",
  'currency.history_note': "Ghi chú",
  'currency.history_empty': "Chưa có thay đổi tỷ giá nào",
  'currency.history_failed': "Không tải được lịch sử tỷ giá",
  'currency.sync': "Sync tỷ giá",
  'currency.sync_hint': "Tỷ giá tự sync 6 giờ/lần (base USD).",
  'currency.sync_done': "Đã sync: {updated} cập nhật, {unchanged} không đổi, {skipped} bỏ qua",
  'currency.sync_failed': "Không sync được tỷ giá",
  'currency.sync_anomaly_title': "{count} tỷ giá biến động quá 10%",
  'currency.sync_anomaly_body': "Các tỷ giá này chưa được áp dụng để tránh dữ liệu nguồn bất thường làm sai giá. Vẫn áp dụng?",
  'currency.sync_force': "Vẫn áp dụng",
  'currency.sync_keep': "Giữ tỷ giá hiện tại",
  'currency.save_failed': "Không lưu được tiền tệ",

  // Post
  'global.posts': 'Bài viết',
  'post.fulltext': 'Nội dung đầy đủ',
  'post.short': 'Tóm tắt',
  'global.featured': 'Nổi bật',
  'post.hit': 'Lượt xem',
  'global.views': 'Lượt xem',
  'global.offers': 'Offers',
  'post.metadesc': 'Mô tả meta',
  'post.metakey': 'Từ khóa meta',
  'post.image': 'Hình ảnh',
  // Log-in Log-out
  'global.account_information': 'Thông tin tài khoản',
  'global.signout': 'Đăng xuất',
  'global.email_required': 'Yêu cầu email',
  'global.password_required': 'Yêu cầu mật khẩu',
  'global.email_not_valid': 'Email không hợp lệ',

  // Site
  'global.site': 'Trang web',
  'sites.hotline': 'Đường dây nóng',
  'sites.locale': 'Ngôn ngữ',
  'sites.from_email': 'Email người gửi',
  'sites.from_name': 'Tên người gửi',
  'sites.currency': 'Tiền tệ',
  'sites.timezone': 'Múi giờ',
  'sites.meta_description': 'Mô tả meta',
  'sites.meta_title': 'Tiêu đề meta',
  'sites.email': 'Email',
  'global.sites': 'Các trang web',

  // Bookings
  'global.order': 'Đặt chỗ',
  'global.orderId': 'Mã đặt chỗ',
  'order.tour_title': 'Tiêu đề tour',
  'order.route_title': 'Tiêu đề tuyến',
  'order.pay_status': 'Trạng thái thanh toán',
  'order.order_status': 'Trạng thái đặt chỗ',
  'order.depart_date': 'Ngày khởi hành',
  'order.customer': 'Khách hàng',
  'order.totalTravelers': 'Tổng số khách',
  'order.totalPrice': 'Tổng giá',
  'order.created': 'Thời gian đặt',
  'order.created_by': 'Người tạo',
  'order.create': 'Tạo đặt chỗ',
  'order.order_seat': 'Phân bổ chỗ ngồi',
  'global.one_way': 'Một chiều',
  'global.two_way': 'Hai chiều',
  'global.time': 'Thời gian',
  'global.search': 'Tìm kiếm',
  'global.departure': 'Điểm đi',
  'global.return': 'Điểm đến',
  'global.assign_operator': 'Gán nhà điều hành',
  'global.assign': 'Gán',
  'global.total': 'Tổng cộng',
  'global.group_code': 'Mã nhóm',
  'order.depart/return': 'Đi / Về',

  // Customers
  'global.customers': 'Khách hàng',
  'global.fullname': 'Họ và tên',
  'global.userId': 'Mã người dùng',
  'global.company_name': 'Tên công ty',
  'global.company_shortname': 'Tên viết tắt',
  'global.company_tax_id': 'Mã số thuế',
  'global.address': 'Địa chỉ',

  // Users
  'global.roles': 'Vai trò',
  'global.menus': 'Quản lý menu',
  'global.users': 'Người dùng',
  // Schedule
  'global.schedule_setting': 'Cài đặt lịch',
  'global.schedule': 'Lịch',
  'global.start_date': 'Ngày bắt đầu',
  'global.end_date': 'Ngày kết thúc',
  'global.start_date_created': 'Ngày bắt đầu (Ngày tạo)',
  'global.end_date_created': 'Ngày kết thúc (Ngày tạo)',
  'global.start_date_login': 'Ngày bắt đầu (Đăng nhập)',
  'global.end_date_login': 'Ngày kết thúc (Đăng nhập)',
  'global.weekdays': 'Các ngày trong tuần',

  // Wishlist
  'global.wishlist': 'Danh sách yêu thích',
  'wishlist.tour_title': 'Tiêu đề tour',
  'wishlist.customer': 'Khách hàng',
  'global.basic': 'Cơ bản',
  'global.item': 'Mục',
  'global.items': 'Các mục',
  'global.sku': 'SKU',
  'global.widgets': 'Widget',
  'global.widget': 'Widget',

  // Menus
  'global.menus': 'Menu',
  'global.menu': 'Menu',
  'global.key': 'Khóa',
  'global.menu_items': 'Các mục menu',
  'global.menu_item': 'Mục menu',

  // FAQ
  'global.faq': 'Câu hỏi thường gặp',
  'global.question': 'Câu hỏi',
  'global.answer': 'Trả lời',

  // Register
  'global.registration_header': 'Đăng ký',
  'global.country': 'Quốc gia',
  'global.mobile': 'Số điện thoại',
  'signup.back_to_login': 'Quay lại đăng nhập',
  'global.continue': 'Tiếp tục',
  'global.close': 'Đóng',

  // Thống kê, đánh giá, v.v.
  'global.statistics': 'Thống kê',
  'global.tour_rates': 'Đánh giá tour',
  'global.tour_options': 'Tùy chọn tour',
  'global.destinations': 'Điểm đến',
  'global.orders': 'Đơn đặt chỗ',
  'global.reviews': 'Đánh giá',
  'global.language': 'Ngôn ngữ',
  'global.currency': 'Tiền tệ',
  'global.your_plan': 'Gói của bạn',
  'global.trial_end': 'Ngày hết hạn dùng thử',
  'global.timezone': 'Múi giờ',
  'global.emai_required': 'Yêu cầu điền email',
  'global.emai_not_valid': 'Email không đúng định dạng',
  'global.confirm_password': 'Xác nhận mật khẩu',
  'global.changepassword': 'Đổi mật khẩu',
  'global.confirm_new_password': 'Xác nhận mật khẩu mới',
  'global.new_password': 'Mật khẩu mới',
  'global.current_password': 'Mật khẩu hiện tại',
  'global.password_not_match': 'Mật khẩu không khớp',
  'global.password_min_charactor': 'Tối thiểu 6 ký tự',
  'global.home': 'Trang chủ',
  'global.vouchers': 'Voucher',
  'sidebar.vouchers': 'Quản lý Voucher',
  'voucher.title': 'Quản lý Voucher',

  // Cabins
  'global.cabins': 'Cabin',
  'global.size': 'Kích thước',
  'global.qty': 'Số lượng',
  'global.route': 'Tuyến đường',

  // Customer Groups
  'global.discount': 'Giảm giá',
  'global.cGroups': 'Nhóm khách hàng',
  'global.group': 'Nhóm',

  // Hops, hệ thống, v.v.
  'global.hops': 'Chặng',
  'global.systems': 'Hệ thống',
  'global.role': 'Vai trò',
  'global.start_time': 'Thời gian bắt đầu',
  'global.start_stop': 'Điểm xuất phát',
  'global.end_stop': 'Điểm kết thúc',
  'global.cabin-rates': 'Giá cabin',
  'global.title_route': 'Tên tuyến',

  // Addons
  'global.addons': 'Dịch vụ bổ sung',
  'global.seat': 'Ghế',
  'global.from_date': 'Từ ngày',
  'global.to_date': 'Đến ngày',

  'global.order_group': 'Nhóm đặt chỗ',
  'global.route_tital': 'Tuyến đường',
  'global.select_customer': 'Chọn khách hàng',
  'global.select_option': 'Chọn tùy chọn',
  'global.order_status': 'Trạng thái đặt chỗ',
  'global.order_cancel': 'Bạn có chắc chắn muốn hủy đơn này?',
  'order.pax': 'Số khách',
  'global.passport': 'Hộ chiếu',
  'global.addnew': 'Thêm mới',
  'global.select_county': 'Chọn quận/huyện',
  'global.cabin': 'Cabin',
  'global.price_type': 'Loại giá',
  'global.voucher': 'Mã giảm giá',
  'global.passengers': 'Hành khách',
  'global.notes': 'Ghi chú',
  'global.order_id': 'Mã đặt chỗ',
  'global.select_date': 'Chọn ngày',
  'global.select_hops': 'Chọn chặng',
  'global.pay_status': 'Trạng thái thanh toán',
  'bill.serial': 'Số hóa đơn',
  'bill.billed_date': 'Ngày thanh toán',
  'bill.amount': 'Số tiền',
  'global.method': 'Phương thức',
  'global.payment_method': 'Phương thức thanh toán',
  'global.bills': 'Hóa đơn',
  'global.notpaid': 'Chưa thanh toán',
  'global.paid': 'Đã thanh toán',
  'global.collect': 'Thu',
  'global.spend': 'Chi',
  'global.cash': 'Tiền mặt',
  'global.card': 'Thẻ',
  'global.bank': 'Ngân hàng',
  'global.insurance': 'Bảo hiểm',
  'global.select_customers': 'Chọn khách hàng',
  'global.select_types': 'Chọn loại',
  'sidebar.dept': 'Công nợ',
  'global.total_debt_begin_period': 'Nợ đầu kỳ',
  'global.total_paid_begin_period': 'Đã trả đầu kỳ',
  'global.total_debt_in_period': 'Nợ trong kỳ',
  'global.total_paid_in_period': 'Đã trả trong kỳ',
  'global.total_debt_end_period': 'Tổng nợ cuối kỳ',
  'global.ar': 'Công nợ phải thu',
  'global.confirm': 'Xác nhận',
  'global.order_confirm': 'Bạn có chắc chắn muốn xác nhận đơn này?',
  'global.bill_confirm': 'Bạn có chắc chắn muốn duyệt hóa đơn này?',
  'global.bookingCalendar': 'Lịch đặt chỗ',
  'global.invoice': 'Hóa đơn',
  'global.list_order_not_paid': 'Danh sách đơn chưa thanh toán',
  'global.export_to_excel': 'Xuất ra Excel',
  'global.report_debt_confirmation': 'Báo cáo xác nhận nợ',
  'global.debt': 'Công nợ',
  'global.bill': 'Hóa đơn',
  'global.record': 'Bản ghi',
  'global.date': 'Ngày',
  'global.hop': 'Chặng',
  'global.addon': 'Dịch vụ bổ sung',
  'global.customer': 'Khách hàng',
  'global.year': 'Năm',
  'global.select_menu': 'Chọn menu',
  'global.select_role': 'Chọn vai trò',
  'global.add_walk_in_customer': 'Thêm khách vãng lai',
  'global.order_details': 'Chi tiết đặt chỗ',
  'global.cabins_order': 'Đặt cabin',
  'global.last_30_day': '30 ngày gần nhất',
  'global.last_7_day': '7 ngày gần nhất',
  'global.last_month': 'Tháng trước',
  'global.this_month': 'Tháng này',
  'global.next_month': 'Tháng sau',
  'global.seller': 'Người bán',
  'global.organization_invitations': 'Lời mời tổ chức',
  'global.search_by_organization': 'Tìm kiếm theo tên tổ chức',
  'global.filter_by_status': 'Lọc theo trạng thái',
  'global.accepted': 'Đã chấp nhận',
  'global.rejected': 'Đã từ chối',
  'global.expired': 'Đã hết hạn',
  'global.cancelled': 'Đã hủy',
  'global.invited_by': 'Được mời bởi',
  'global.confirm_cancel_invitation': 'Bạn có chắc chắn muốn hủy lời mời này?',
  'global.send_email': 'Gửi email',
  'global.sale': 'Bán hàng',
  'global.finance': 'Tài chính',
  'global.finance_cost_links': 'Thống kê chi phí',
  'global.carriages': 'Toa xe',
  'global.logo': 'Logo',
  'global.content': 'Nội dung',
  'global.path': 'Đường dẫn',
  'global.seat_allocation': 'Phân bổ ghế',
  'global.cabinSerials': 'Số hiệu cabin',
  'global.title_carriage': 'Tên toa xe',
  'global.title_cabin': 'Tên cabin',
  'global.select_carriage': 'Chọn toa xe',
  'global.order_seat': 'Đặt ghế',
  'global.order_seats': 'Đặt nhiều ghế',
  'global.Seat': 'Ghế',
  'global.depart_seating': 'Ghế chiều đi',
  'global.return_seating': 'Ghế chiều về',
  'global.seating': 'Sơ đồ ghế',
  'global.summary': 'Tổng kết',
  'global.action': 'Hành động',
  'global.created_at': 'Ngày tạo',
  'global.created_by': 'Người tạo',
  'global.roundtrip': 'Khứ hồi',
  // Site meta, layout, socials
  'sites.url': 'Địa chỉ URL',
  'sites.ga_script': 'Mã Google Analytics',
  'global.meta_data': 'Dữ liệu meta',
  'global.meta_title': 'Tiêu đề meta',
  'global.meta_description': 'Mô tả meta',
  'global.meta_keywords': 'Từ khóa meta',
  'global.before_head': 'Trước thẻ head',
  'global.before_body': 'Trước thẻ body',
  'global.layout': 'Bố cục',
  'global.socials': 'Mạng xã hội',

  // Status
  'global.all': 'Tất cả',
  'global.pending': 'Đang chờ',
  'global.confirmed': 'Đã xác nhận',
  'global.cancelled': 'Đã hủy',
  'global.refund': 'Hoàn tiền',
  'global.mark_as_paid': 'Đánh dấu đã thanh toán',

  'global.super': 'Super',
  'global.admin': 'Quản trị viên',
  'global.staff': 'Nhân viên',
  'global.agent': 'Đại lý',
  'global.upgrade': 'Nâng cấp',
  'global.cabin_no': 'Số cabin',
  'global.carriage': 'Toa xe',
  'global.cabin_type': 'Loại cabin',
  'global.view_seat': 'Xem ghế',
  'global.view': 'Xem',
  'global.ok': 'Đồng ý',
  'global.seats': 'Các ghế',
  'global.time_period': 'Khoảng thời gian',
  'global.booked_seats': 'Ghế đã đặt',
  'global.allocated_seat': 'Ghế đã phân bổ',
  'global.revenue': 'Doanh thu',
  'global.revenue_report': 'Báo cáo doanh thu',
  'global.cabins_performance': 'Hiệu suất cabin',
  'global.created_date': 'Ngày tạo',
  'global.depart_date': 'Ngày đi',
  'global.download': 'Tải xuống',
  'global.permission': 'Quyền',
  'global.permissions': 'Các quyền',
  'permissions.decline': 'Từ chối',
  'permissions.allow': 'Cho phép',
  'global.e_ticket': 'Vé điện tử',
  'global.internal_notes': 'Ghi chú nội bộ',
  'global.information_customer': 'Thông tin khách hàng',
  'global.cgroup': 'Nhóm khách hàng',
  'global.order_information': 'Thông tin đặt chỗ',
  'global.accountant_email': 'Email kế toán',
  'global.more': 'Thêm',
  'global.full': 'Đầy đủ',
  'global.deposited': 'Đã đặt cọc',
  'global.payment_type': 'Loại thanh toán',
  'global.payment_status': 'Trạng thái thanh toán',
  'global.contact_information': 'Thông tin liên hệ',
  'global.contacts': 'Liên hệ',
  'global.contact': 'Liên hệ',
  'global.add_contact': 'Thêm liên hệ',
  'global.office': 'Văn phòng',
  'global.select_contact': 'Chọn liên hệ',
  'global.select_seller': 'Chọn người bán',
  'global.input_group_code': 'Nhập mã nhóm',
  'global.input_pax': 'Nhập số khách',
  'global.input_order_notes': 'Nhập ghi chú đơn hàng',
  'global.input_order_internal_notes': 'Nhập ghi chú nội bộ đơn hàng',
  'global.input_contact_name': 'Nhập tên liên hệ',
  'global.input_contact_email': 'Nhập email liên hệ',
  'global.input_contact_mobile': 'Nhập số điện thoại liên hệ',
  'validate.is_not_email': 'Trường này không phải email',
  'validate.is_not_phone_number': 'Trường này không phải số điện thoại',
  'order.select_other_contact': 'Khác',
  'global.select_hop': 'Chọn chặng',
  'global.select_route': 'Chọn tuyến đường',
  'global.book': 'Đặt chỗ',
  'global.user': 'Người dùng',
  'golobal.subscription_order': 'Đơn đặt dịch vụ định kỳ',
  'global.subscriptions': 'Đăng ký',
  'global.subscription_plan': 'Gói đăng ký',
  'global.period': 'Thời hạn',
  'global.user_id': 'ID người dùng',
  'global.renewal_count': 'Số lần gia hạn',
  'golobal.service_order': 'Đơn đặt dịch vụ',
  'golobal.product_order': 'Đơn đặt sản phẩm',
  'golobal.service': 'Dịch vụ',
  'golobal.product': 'Sản phẩm',
  'golobal.Supplier': 'Nhà cung cấp',
  'golobal.tools': 'Công cụ',
  'golobal.landing_page': 'Trang đích',
  'golobal.reports': 'Báo cáo',
  'global.save_success': 'Lưu thành công',
  'global.save_failed': 'Lưu thất bại',
  'global.guide_number': 'Số hướng dẫn viên',
  'global.input_guide_number': 'Nhập số hướng dẫn viên',
  'global.input_your_password': 'Vui lòng nhập mật khẩu!',
  'global.input_beds': 'Vui lòng nhập tên giường hoặc xóa trường này',
  'global.input_email_or_delete': 'Vui lòng nhập email hoặc xóa trường này',
  'global.select_destination_start': 'Chọn điểm đi',
  'global.select_destination_end': 'Chọn điểm đến',
  'placeholder.select_hop': 'Chọn chặng',
  'placeholder.select_addon': 'Chọn dịch vụ bổ sung',
  'placeholder.from': 'Từ',
  'placeholder.to': 'Đến',
  'placeholder.select_category': 'Chọn danh mục',
  'placeholder.select_customer_group': 'Chọn nhóm khách hàng',
  'global.select_user': 'Chọn người dùng',
  'placeholder.select_user': 'Chọn người dùng',
  'global.select_permission': 'Chọn quyền',
  'global.select_all': 'Chọn tất cả',
  'global.advanced_settings_for_each_user':
    'Cài đặt nâng cao cho từng người dùng',
  'note.reload_page': 'Cần tải lại trang sau khi chỉnh sửa xong',
  'global.history': 'Lịch sử',
  'global.clear': 'Xóa',
  'history.from_date': 'Từ ngày',
  'history.to_date': 'Đến ngày',
  'history.week_days': 'Các ngày trong tuần',
  'global.reload': 'Tải lại',
  'global.clear_rate_confirm': 'Bạn có chắc chắn muốn xóa dữ liệu này?',
  'placeholder.booking_id_or_code': 'Mã đặt chỗ hoặc mã code',
  'global.special_notes': 'Ghi chú đặc biệt',
  'placeholder.input_special_notes': 'Nhập ghi chú đặc biệt',
  'global.choice_a_time_period': 'Chọn khoảng thời gian',
  'global.not_found': 'Không tìm thấy',
  'global.select_a_customer': 'Chọn khách hàng',
  'placeholder.select_customer': 'Chọn khách hàng',
  'placeholder.input_notes': 'Nhập ghi chú',
  'placeholder.input_description': 'Nhập mô tả',
  'placeholder.input_budget': 'Không bắt buộc. Số tiền người đăng request có thể trả',
  'placeholder.input_min_budget':
    'Không bắt buộc. Số tiền tối thiểu người đăng request có thể trả',
  'placeholder.input_max_budget':
    'Không bắt buộc. Số tiền tối đa người đăng request có thể trả',
  'placeholder.select_creator': 'Chọn người tạo',
  'placeholder.select_status': 'Chọn trạng thái',
  'placeholder.payment_from': 'Thanh toán từ',
  'placeholder.payment_to': 'Thanh toán đến',
  'global.initialization_time': 'Thời gian khởi tạo',
  'placeholder.input_title': 'Nhập tiêu đề',
  'placeholder.input_code': 'Nhập mã',
  'placeholder.select_route': 'Chọn tuyến đường',
  // Error, warning, success, placeholder, booking, passengers, refund, payment, tour, v.v.
  'error.quantity_is_not_the_same': 'Số lượng không khớp với số lượng đã đặt',
  'global.addons_booking': 'Dịch vụ bổ sung',
  'error.missing_addon': 'Vui lòng chọn dịch vụ bổ sung',
  'warning.not_found_carriages': 'Không có toa xe khả dụng',
  'global.individual': 'Cá nhân',
  'global.available': 'Có sẵn',
  'global.booking_statistics': 'Thống kê đặt chỗ',
  'global.total_number_of_tickets': 'Tổng số vé',
  'global.sold': 'Đã bán',
  'global.remaining': 'Còn lại',
  'global.capacity': 'Sức chứa',
  'global.general_capacity': 'Sức chứa chung',
  'global.files_manager': 'Quản lý tệp',
  'global.file_manager': 'Quản lý tệp',
  'global.manager.title': 'Quản lý menu',
  'global.manager.list': 'Danh sách menu',
  'global..manager.role': 'Menu theo vai trò',
  'global.manager.user': 'Menu theo người dùng',
  'error.upload_file': 'Lỗi tải tệp lên. Vui lòng thử lại.',
  'success.upload_file': 'Tải tệp lên thành công!',
  'global.create_folder': 'Tạo thư mục',
  'global.new_folder': 'Thư mục mới',
  'global.create_new_folder': 'Tạo thư mục mới',
  'global.upload_files': 'Tải tệp lên',
  'global.click_or_drag_files_to_upload':
    'Nhấp hoặc kéo thả tệp vào khu vực này để tải lên',
  'global.upload_hint':
    'Hỗ trợ tải lên đơn lẻ hoặc hàng loạt. Nghiêm cấm tải lên dữ liệu công ty hoặc các tệp khác',
  'global.download_started': 'Bắt đầu tải xuống',
  'global.failed_to_download_file': 'Không thể tải xuống tệp',
  'global.failed_to_preview_file': 'Không thể xem trước tệp',
  'global.copied_url_to_clipboard': 'Đã sao chép URL vào clipboard',
  'global.failed_to_copy_url': 'Không thể sao chép URL',
  'global.failed_to_load_directory_contents': 'Không thể tải nội dung thư mục',
  'global.please_enter_folder_name': 'Vui lòng nhập tên thư mục',
  'global.folder_created_successfully': 'Tạo thư mục thành công',
  'global.failed_to_create_folder': 'Không thể tạo thư mục',
  'global.file_uploaded_successfully': 'Tải tệp lên thành công',
  'global.failed_to_upload_file': 'Không thể tải tệp lên',
  'global.delete_items': 'Xóa các mục',
  'global.confirm_delete_items': 'Bạn có chắc chắn muốn xóa {count} mục?',
  'global.items_deleted_successfully': 'Xóa các mục thành công',
  'global.failed_to_delete_items': 'Không thể xóa các mục',
  'placeholder.input_folder_name': 'Nhập tên thư mục',
  'global.folder_name': 'Tên thư mục',
  'error.create_folder': 'Lỗi tạo thư mục. Vui lòng thử lại.',
  'error.delete_file': 'Lỗi xóa, vui lòng thử lại.',
  'error.folder_name': 'Tên thư mục không hợp lệ, vui lòng thử lại.',
  'error.missing_file_upload': 'Vui lòng chọn tệp để tải lên.',
  'placeholder.select_date': 'Chọn ngày',
  'placeholder.input_email': 'Nhập email',
  'global.send': 'Gửi',
  'global.download_addon_booking': 'Tải dịch vụ bổ sung',
  'error.send_email': 'Lỗi gửi email. Vui lòng thử lại.',
  'global.send_email_success': 'Gửi email thành công',
  'global.customer_name': 'Tên khách hàng',
  'global.seated_by': 'Xếp chỗ bởi',
  'global.seated_date': 'Ngày xếp chỗ',
  'sidebar.invoice': 'Hóa đơn',
  'global.booked_from': 'Đặt từ ngày',
  'global.booked_to': 'Đặt đến ngày',
  'global.amount_of_money': 'Số tiền',
  'global.track': 'Theo dõi',
  'placeholder.input_track': 'Nhập thông tin theo dõi',
  'global.amenities': 'Tiện nghi',
  'global.icon': 'Biểu tượng',
  'error.must_contain_least_one_value':
    'Phải có ít nhất một thông tin hành khách',
  'global.representative_passenger': 'Hành khách đại diện',
  'placeholder.input_firstname': 'Nhập tên',
  'placeholder.input_lastname': 'Nhập họ',
  'error.missing_passenger_information':
    'Vui lòng nhập ít nhất một thông tin hành khách',
  'global.refund_policy': 'Chính sách hoàn tiền',
  'global.refund_policies': 'Các chính sách hoàn tiền',
  'global.cancel_fee': 'Phí hủy',
  'global.hours': 'Giờ',
  'global.is_default': 'Mặc định',
  'global.select_tours': 'Chọn tour',
  'global.payments': 'Các khoản thanh toán',
  'global.payment_date': 'Ngày thanh toán',
  'global.payment': 'Thanh toán',
  'global.refund_recording': 'Ghi nhận hoàn tiền',
  'global.transaction': 'Giao dịch',
  'global.transactions': 'Các giao dịch',
  'global.penalty_date': 'Ngày phạt',
  'global.today': 'Hôm nay',
  'global.penalty_status': 'Trạng thái phạt',
  'global.no_payment_yet': 'Chưa có thanh toán',
  'global.tour': 'Tour',
  'placeholder.input_amount': 'Nhập số tiền',
  'success.refund_recorded': 'Ghi nhận hoàn tiền thành công',
  'global.adults': 'Người lớn',
  'global.children': 'Trẻ em',
  'global.infants': 'Trẻ nhỏ',
  'global.pickup_location': 'Điểm đón',
  'global.income': 'Thu nhập',
  'global.expense': 'Chi phí',
  'global.pay': 'Thanh toán',
  'global.debit': 'Ghi nợ',
  'global.amount': 'Số tiền',
  'global.transaction_date': 'Ngày giao dịch',
  'global.guest_payment_date': 'Ngày giao dịch khách',
  'global.policy_penalty_name': 'Tên chính sách phạt',
  'global.guest_payment': 'Giao dịch khách',
  'global.guest_payment_detail': 'Chi tiết giao dịch khách',
  'global.waiting_approve': 'Chờ phê duyệt',
  'global.created_payments': 'Các khoản thanh toán đã tạo',
  'tour.pickup_offered': 'Có đón khách',
  'global.pickup_offer': 'Đề nghị đón khách',
  'global.both': 'Cả hai',
  'global.free_cancel': 'Hủy miễn phí',
  'global.penalty': 'Phạt',
  'global.cancel_booking': 'Hủy đặt chỗ',
  'global.pickup_time': 'Thời gian đón',
  'global.create_transaction': 'Tạo giao dịch',
  'global.depart_value': 'Giá trị đi',
  'global.penalty_amount': 'Số tiền phạt',
  'global.add_pickup': 'Thêm điểm đón',
  'global.select_meeting_type': 'Chọn loại điểm gặp mặt',
  'global.book_tour': 'Đặt tour: ',
  'global.endWorkingTime': 'Thời gian kết thúc làm việc',

  // payment method
  'global.merchant_id': 'Mã Merchant',
  'global.secret_key': 'Khóa bí mật',

  'global.send_link_payment': 'Gửi liên kết thanh toán',
  'global.filter_params': 'Bộ lọc',
  'global.category_id': 'Danh mục',
  'global.destination_id': 'Điểm đến',

  'global.market': 'Thị trường',
  'global.flat': 'Cố định',
  'global.commission_amount': 'Số tiền hoa hồng',

  'global.waiting': 'Đang chờ',

  'global.select_operators': 'Chọn nhà điều hành',
  'order.supplier_status': 'Trạng thái nhà cung cấp',
  'global.free_cancel_date': 'Ngày hủy miễn phí',
  'global.time_start': 'Thời gian bắt đầu',
  'global.supplier_total': 'Tổng nhà cung cấp',
  'global.edit_pickup': 'Sửa điểm đón',
  'global.edit_passengers': 'Sửa hành khách',
  'global.drop_off': 'Điểm trả khách',
  'global.driver_notes': 'Ghi chú tài xế',
  'global.policies': 'Chính sách',
  'global.cancellation_policy_summary': 'Tóm tắt hủy',
  'global.free_cancellation': 'Hủy miễn phí',
  'global.service_fee': 'Phí dịch vụ',
  'global.ordering': 'Đặt hàng',
  'global.price_cron': 'Tự động cập nhật giá',
  'global.unit': 'Đơn vị',

  'global.passenger': 'Hành khách',

  'global.subtotal': 'Tạm tính',
  'global.refund_amount': 'Số tiền hoàn',
  'global.cancellation_date': 'Ngày hủy',
  'global.cancellation_fee': 'Phí hủy',
  'global.cache_reset': 'Đặt lại bộ nhớ đệm',
  'global.additional_info': 'Thông tin bổ sung',
  'global.driver': 'Tài xế',

  'global.select_type': 'Chọn loại',
  'global.brand': 'Thương hiệu',

  // CRM
  'global.crm': 'CRM',
  'global.segments': 'Phân khúc',
  'global.templates': 'Mẫu email',
  'global.app': 'Ứng dụng',
  'global.select_app': 'Chọn ứng dụng',
  'global.campaigns': 'Chiến dịch',
  'global.campaign_roles': 'Vai trò chiến dịch',
  'global.phone_code': 'Mã vùng điện thoại',
  'global.action_date': 'Ngày thực hiện',
  'global.date_of_birth': 'Ngày sinh',
  'global.lead_status': 'Trạng thái khách hàng tiềm năng',
  'global.new': 'Mới',
  'global.open': 'Mở',
  'global.in_progress': 'Đang xử lý',
  'global.unqualified': 'Không đủ điều kiện',
  'global.attempted_to_contact': 'Đã cố liên hệ',
  'global.connected': 'Đã kết nối',
  'global.bad_timing': 'Không đúng thời điểm',
  'global.subscribed': 'Đã đăng ký',
  'global.unsubscribed': 'Đã hủy đăng ký',
  'global.owner': 'Chủ sở hữu',
  'global.subject': 'Chủ đề',
  'global.email_attachments': 'Tệp đính kèm',
  'global.email_body_preview': 'Xem trước',
  'global.email_body_edit': 'Sửa nội dung',
  'global.email_attachments_hint': 'Tải file từ máy lên (tối đa 20MB: ảnh, PDF, Word, Excel, PowerPoint) hoặc dán link có sẵn. App lấy template sẽ nhận các link này để đính kèm khi gửi.',
  'global.email_attachment_name': 'Tên file',
  'global.email_attachment_upload': 'Tải file lên',
  'global.email_attachment_view': 'Xem file',
  'global.email_attachment_add_link': 'Thêm bằng link',
  'global.email_attachment_upload_failed': 'Tải lên thất bại: {name}',
  'global.email_attachment_too_large': '{name} lớn hơn 20MB',
  'global.email_attachment_link_invalid': 'Link phải bắt đầu bằng http:// hoặc https://',
  'global.once': 'Một lần',
  'global.daily': 'Hàng ngày',
  'global.repeat': 'Lặp lại',
  'global.audiences': 'Đối tượng',
  'global.analytics': 'Phân tích',
  'global.opened': 'Đã mở',
  'global.schedule_date': 'Ngày lên lịch',
  'global.send_now': 'Gửi ngay',
  'global.campaign_key': 'Mã chiến dịch',
  'global.segment': 'Phân khúc',
  'global.template': 'Mẫu',
  'global.links': 'Liên kết',
  'global.conditions': 'Điều kiện',
  'global.is': 'Là',
  'global.is_not': 'Không là',
  'global.contain': 'Chứa',
  'global.not_contain': 'Không chứa',
  'global.start_with': 'Bắt đầu với',
  'global.end_with': 'Kết thúc với',
  'global.send_index': 'Gửi IndexNow',
  'global.send_success': 'Gửi thành công',
  'global.source': 'Nguồn',
  'global.apply': 'Áp dụng',
  'global.sent': 'Đã gửi',
  'global.not_send': 'Chưa gửi',
  'global.sent_date': 'Ngày gửi',
  'global.recipients': 'Người nhận',
  'global.campaign_status': 'Trạng thái chiến dịch',
  'global.running': 'Đang chạy',
  'global.stopped': 'Đã dừng',
  'global.create_segment': 'Tạo phân khúc',
  'global.clicked': 'Đã nhấp',
  'global.start': 'Bắt đầu',
  'global.stop': 'Dừng',
  'global.completed': 'Hoàn thành',
  'global.not_open': 'Chưa mở',
  'global.not_click': 'Chưa nhấp',
  'global.promotions': 'Khuyến mãi',
  'global.promotion': 'Khuyến mãi',
  'global.used_from': 'Sử dụng từ',
  'global.used_to': 'Sử dụng đến',
  'global.used_at': 'Sử dụng lúc',
  'global.discounts': 'Các giảm giá',
  'placeholder.select_group': 'Chọn nhóm',
  'global.customer_group': 'Nhóm khách hàng',
  'global.booked_at_from': 'Đặt từ ngày',
  'global.booked_at_to': 'Đặt đến ngày',
  'placeholder.booked_at_from': 'Đặt từ ngày',
  'placeholder.booked_at_to': 'Đặt đến ngày',
  'placeholder.used_at_from': 'Sử dụng từ ngày',
  'placeholder.used_at_to': 'Sử dụng đến ngày',
  'global.booked_at': 'Đặt lúc',
  'global.app_id': 'Mã ứng dụng',
  'global.body': 'Nội dung',
  'global.role_management': 'Quản lý vai trò',
  'global.role_name': 'Tên vai trò',
  'global.role_description': 'Mô tả',
  'global.role_key': 'Mã vai trò',
  'global.landing_page_title': 'Trang đích',
  'global.landing_page_full_name': 'Họ và tên',
  'global.landing_page_email': 'Email',
  'global.landing_page_area': 'Khu vực',
  'global.landing_page_work_preference': 'Hình thức làm việc',
  'global.landing_page_file': 'Tệp',
  'global.sequence': 'Thứ tự',

  'global.menu_sidebar_seller': 'Người bán',
  'global.seller_management': 'Quản lý người bán',
  'global.seller_management_profession': 'Nghề nghiệp',
  'global.seller_management_about': 'Giới thiệu',
  'global.seller_management_banner_picture': 'Ảnh banner',
  'global.seller_management_experiences': 'Kinh nghiệm',
  'global.seller_management_educations': 'Học vấn',
  'global.seller_management_addresses': 'Địa chỉ',
  'global.seller_management_bank_accounts': 'Tài khoản ngân hàng',
  'global.seller_management_skills': 'Kỹ năng',
  'global.seller_management_certificates': 'Chứng chỉ',
  'global.seller_management_IsOrgOwner': 'Là chủ tổ chức',
  'global.seller_management_user_id': 'Mã người dùng',
  'global.seller_management_Organization_id': 'Mã tổ chức',

  'global.seller_form_label_seller': 'Người bán',
  'global.seller_form_label_user': 'Người dùng',
  'global.seller_form_label_organization': 'Tổ chức',

  'global.seller_form_label_company_name': 'Tên công ty',
  'global.seller_form_label_company_address': 'Địa chỉ công ty',
  'global.seller_form_label_job_position': 'Vị trí công việc',
  'global.seller_form_label_from_year': 'Từ năm',
  'global.seller_form_label_to_year': 'Đến năm',

  'global.seller_form_label_address': 'Địa chỉ',
  'global.seller_form_label_major': 'Chuyên ngành',
  'global.seller_form_label_school_name': 'Tên trường',

  'global.seller_form_label_street_address': 'Địa chỉ đường phố',
  'global.seller_form_label_apartment_unit': 'Căn hộ/Đơn vị',
  'global.seller_form_label_city': 'Thành phố',
  'global.seller_form_label_state_province': 'Tỉnh/Thành phố',
  'global.seller_form_label_country': 'Quốc gia',
  'global.seller_form_primary_address': 'Địa chỉ chính (hiển thị trên web)',
  'global.seller_form_country_unlinked': 'Chưa gắn quốc gia - bấm Sửa và chọn lại',
  'global.seller_form_label_latitude': 'Vĩ độ',
  'global.seller_form_label_longitude': 'Kinh độ',

  'global.seller_form_label_card_type': 'Loại thẻ',
  'global.seller_form_label_last_4_digits': '4 số cuối',
  'global.seller_form_label_expiry_date': 'Ngày hết hạn',

  'global.seller_form_label_certificate_name': 'Tên chứng chỉ',
  'global.seller_form_label_location': 'Địa điểm',
  'global.seller_form_label_issued_date': 'Ngày cấp',
  'global.seller_form_label_issuer': 'Nơi cấp',
  'global.seller_form_label_image_url': 'Đường dẫn hình ảnh',

  'global.organization': 'Tổ chức',
  'global.organization_manager_title': 'Quản lý tổ chức',
  'global.organization_manger_table_name': 'Tên',
  'global.organization_manger_table_description': 'Mô tả',
  'global.organization_manger_table_logo': 'Logo',
  'global.organization_manger_table_website': 'Trang web',
  'global.organization_manger_table_contact_email': 'Email liên hệ',
  'global.organization_manger_table_contact_phone': 'Số điện thoại liên hệ',
  'global.organization_manger_table_address': 'Địa chỉ',
  'global.organization_manger_table_social_media': 'Mạng xã hội',
  'global.organization_manger_table_business_hours': 'Giờ làm việc',

  'global.organization_form_label_street_address': 'Địa chỉ đường',
  'global.organization_form_label_city': 'Thành phố',
  'global.organization_form_label_country': 'Quốc gia',

  'global.organization_form_label_day': 'Ngày',
  'global.organization_form_label_open_time': 'Giờ mở cửa',
  'global.organization_form_label_close_time': 'Giờ đóng cửa',

  'global.invalid_phone': 'Số điện thoại không hợp lệ.',
  'global.invalid_email': 'Email không hợp lệ.',
  'global.email_already_exists': 'Email đã tồn tại.',
  'global.mobile_already_exists': 'Số điện thoại đã tồn tại.',
  'global.website_invalid': 'URL trang web không hợp lệ.',
  'global.date_not_in_past': 'Không thể chọn ngày trong quá khứ',
  'global.end_date_after_start_date': 'Ngày kết thúc phải sau ngày bắt đầu',
  'global.required-referals': 'Vui lòng chọn người giới thiệu',
  'global.required-user': 'Vui lòng chọn người dùng',
  'global.required-amount': 'Vui lòng nhập số lượng',
  'global.required-commission-earned': 'Vui lòng nhập hoa hồng đã nhận',
  'global.required-commission-type': 'Vui lòng chọn loại hoa hồng',
  'global.required-converted-at': 'Vui lòng chọn thời gian',
  'global.seller_management_shop-name': 'Tên cửa hàng',
  'global.seller_management_service_count': 'Dịch vụ',
  'global.created_at': 'Ngày tạo',
  'global.type': 'Loại',
  'global.card_number_last4': 'Số thẻ',
  'global.cardholder_name': 'Tên chủ thẻ',
  'global.card_brand': 'Thương hiệu thẻ',
  'global.card_exp_month': 'Tháng hết hạn',
  'global.card_exp_year': 'Năm hết hạn',
  'global.is_verified': 'Đã xác thực',
  'global.default': 'Mặc định',
  'global.sku_already_exists': 'Mã SKU đã tồn tại. Vui lòng sử dụng mã khác.',

  'global.service_fee': 'Phí dịch vụ',
  'global.commission_fee': 'Phí hoa hồng',
  'global.withdrawal_status': 'Trạng thái rút tiền',
  'global.cancel_status': 'Trạng thái hủy',
  'global.completed_date': 'Ngày hoàn thành',
  'global.refund_amount': 'Số tiền hoàn',
  'global.refund_notes': 'Ghi chú hoàn tiền',
  'global.refund_date': 'Ngày hoàn tiền',
  'global.quantity': 'Số lượng',
  'global.product_snapshot_name': 'Tên sản phẩm',
  'global.customer_email': 'Email khách hàng',
  'global.product_order': 'Trạng thái đơn hàng',
  'global.order_product_status': 'Trạng thái đơn',

  'placeholder.select_product': 'Chọn sản phẩm',
  'placeholder.select_shop': 'Chọn shop',
  'placeholder.input_service_fee': 'Nhập phí dịch vụ',
  'placeholder.input_commission_fee': 'Nhập phí hoa hồng',
  'placeholder.input_method': 'Nhập phương thức',
  'placeholder.input_type': 'Nhập loại',
  'placeholder.select_order_status': 'Chọn trạng thái đơn hàng',
  'placeholder.select_pay_status': 'Chọn trạng thái thanh toán',
  'global.edit_success': 'Sửa thành công!',
  'global.add_success': 'Thêm thành công!',
  'global.edit_product_order_success':
    'Cập nhật thông tin đơn hàng thành công!',
  'global.add_product_order_success': 'Thêm đơn hàng thành công',
  'global.closed': 'Hoàn thành',
  'global.spam': 'Spam',
  'global.not_spam': 'Không',
  'global.brand.duplicate_name':
    'Tên thương hiệu đã tồn tại, vui lòng chọn tên khác.',
  'global.search_by_email': 'Tìm kiếm theo email...',
  'global.seller': 'Người bán',
  'global.please_select_country': 'Vui lòng chọn một quốc gia',
  'global.select_expert': 'Chọn chuyên gia',
  'global.search_by_seller': 'Tìm kiếm theo người bán',
  'global.search_by_customer': 'Tìm kiếm theo người mua',
  'global.create_success': 'Tạo thành công!',
  'global.update_success': 'Sửa thành công!',
  'global.request_required': 'Yêu cầu là bắt buộc',
  'global.public_offers_title': 'Offer công khai',
  'global.service_required': 'Dịch vụ là bắt buộc',
  'global.select_request': 'Chọn yêu cầu',
  'global.select_service': 'Chọn dịch vụ',
  'global.title_required': 'Tiêu đề là bắt buộc',
  'global.description_required': 'Mô tả là bắt buộc',
  'global.seller_required': 'Người bán là bắt buộc',
  'global.customer_required': 'Khách hàng là bắt buộc',
  'global.price_required': 'Giá là bắt buộc',
  'global.status_required': 'Trạng thái là bắt buộc',
  'global.type_required': 'Loại là bắt buộc',
  'global.description_max_1000': 'Mô tả không được vượt quá 1000 ký tự',
  'global.seller_form_label_year_of_certification': 'Năm cấp chứng chỉ',
  'global.seller_form_label_link_certificate': 'Liên kết chứng chỉ',
  'global.seller_form_label_image': 'Hình ảnh chứng chỉ',
  'global.seller_duplicate_user_title': 'Người dùng đã có hồ sơ người bán',
  'global.seller_duplicate_user_message':
    'Người dùng này đã có hồ sơ người bán. Vui lòng chọn người dùng khác và thử lại.',
  'global.shipping_status': 'Trạng thái giao hàng',
  'global.placeholder_shipping_status': 'Chỉnh trạng thái giao hàng',
  'global.enter_skills': 'Nhập kỹ năng',
  'global.select_order': 'Chọn đơn hàng',

  'global.sb_com_product': 'Hoa hồng người bán sản phẩm (%)',
  'global.sb_com_product_required': 'Vui lòng nhập hoa hồng người bán sản phẩm',

  'global.sb_com_service': 'Hoa hồng người bán dịch vụ (%)',
  'global.sb_com_service_required': 'Vui lòng nhập hoa hồng người bán dịch vụ',

  'global.sb_com_service_user': 'Hoa hồng người mua dịch vụ (%)',
  'global.sb_com_service_user_required':
    'Vui lòng nhập hoa hồng người mua dịch vụ',

  'global.released_payment_days':
    'Người bán có thể rút tiền sau X ngày kể từ khi đơn hàng hoàn thành',
  'global.released_payment_days_required': 'Vui lòng nhập số ngày rút tiền',

  'global.withdrawal': 'Rút tiền',
  'global.transaction_ref': 'Mã tham chiếu giao dịch',
  'global.processed_at': 'Thời gian xử lý',
  'global.add-app-settings': 'Thêm cấu hình ứng dụng',
  'global.edit-app-settings': 'Chỉnh sửa cấu hình ứng dụng',
  'global.withdrawal_min_amount': 'Số tiền rút tối thiểu',
  'global.withdrawal_min_amount_required': 'Số tiền rút tối thiểu là bắt buộc',
  'global.withdrawal_min_amount_warning':
    'Số tiền rút hiện tại ({currentAmount}) nhỏ hơn mức tối thiểu yêu cầu ({minAmount}). Không thể phê duyệt yêu cầu rút tiền này.',
  'global.withdrawal_min_amount_error':
    'Không thể phê duyệt yêu cầu rút tiền. Số tiền tối thiểu yêu cầu là ${minAmount}. Số tiền hiện tại là ${currentAmount}.',
  'global.force_update_version': 'Phiên bản bắt buộc cập nhật',
  'global.soft_update_version': 'Phiên bản gợi ý cập nhật',
  'global.latest_version': 'Phiên bản mới nhất trên store',
  'global.ios_store_url': 'Link App Store (iOS)',
  'global.android_store_url': 'Link Google Play (Android)',
  'global.version_check_namespace_hint':
    'Dùng namespace version_check hoặc version_check.{app-flavor} (vd: version_check.strongbody-ai). Platform phải là App.',
  'global.app_setting_type': 'Loại cấu hình',
  'global.app_setting_type_system': 'Hệ thống',
  'global.app_setting_type_version_check': 'Version check (mobile app)',
  'global.app_setting_namespace_preset': 'Chọn namespace mẫu',
  'global.search_by_name': 'Tìm kiếm theo tên...',
  'global.expiration_days': 'Số ngày hết hạn',
  'global.enable_tiering': 'Bật phân cấp',
  'global.allow_negative_balance': 'Cho phép số dư âm',
  'global.valid_from': 'Có hiệu lực từ',
  'global.valid_to': 'Có hiệu lực đến',
  'global.days': 'ngày',
  'global.true': 'Có',
  'global.false': 'Không',
  'global.enter_expiration_days': 'Nhập số ngày hết hạn',
  'interest.fetch_error': 'Lấy danh sách interest thất bại.',
  'interest.children_button': 'Con',
  'interest.professions_button': 'Nghề nghiệp',
  'interest.children_load_failed': 'Không thể tải danh sách interest con.',
  'interest.children_remove_select_warning':
    'Vui lòng chọn interest con để xoá.',
  'interest.children_remove_success': 'Xoá interest con thành công.',
  'interest.children_remove_failed': 'Xoá interest con thất bại.',
  'interest.children_add_select_warning': 'Vui lòng chọn interest con để thêm.',
  'interest.children_add_success': 'Thêm interest con thành công.',
  'interest.children_add_failed': 'Thêm interest con thất bại.',
  'interest.add_children_label': 'Thêm interest con:',
  'interest.select_children_placeholder': 'Chọn interest con để thêm',
  'interest.current_children_label': 'Interest con hiện tại:',
  'interest.manage_children_title': 'Quản lý interest con cho: {name}',
  'interest.professions_load_failed': 'Không thể tải danh sách nghề nghiệp.',
  'interest.professions_available_load_failed':
    'Không thể tải danh sách nghề nghiệp có thể chọn.',
  'interest.professions_child_only_warning':
    'Chỉ có thể quản lý nghề nghiệp cho interest con, không áp dụng cho interest cha.',
  'interest.professions_parent_hint':
    'Interest này là interest cha nên không thể gán nghề nghiệp.',
  'interest.professions_remove_select_warning':
    'Vui lòng chọn nghề nghiệp để xoá.',
  'interest.professions_remove_success': 'Xoá nghề nghiệp thành công.',
  'interest.professions_remove_failed': 'Xoá nghề nghiệp thất bại.',
  'interest.professions_add_select_warning':
    'Vui lòng chọn nghề nghiệp để thêm.',
  'interest.professions_add_success': 'Thêm nghề nghiệp thành công.',
  'interest.professions_add_failed': 'Thêm nghề nghiệp thất bại.',
  'interest.add_professions_label': 'Thêm nghề nghiệp:',
  'interest.select_professions_placeholder': 'Chọn nghề nghiệp để thêm',
  'interest.current_professions_label': 'Nghề nghiệp hiện tại:',
  'interest.manage_professions_title': 'Quản lý nghề nghiệp cho: {name}',
  'interest.tree_load_failed': 'Không thể tải cây interest.',
  'interest.load_failed': 'Không thể tải dữ liệu interest.',
  'profession.fetch_error': 'Lấy danh sách profession thất bại.',
  'profession.children_load_failed': 'Không thể tải profession con.',
  'profession.children_remove_select_warning':
    'Vui lòng chọn profession con để xoá.',
  'profession.children_remove_success': 'Xoá profession con thành công.',
  'profession.children_remove_failed': 'Xoá profession con thất bại.',
  'profession.children_add_select_warning':
    'Vui lòng chọn profession con để thêm.',
  'profession.children_add_success': 'Thêm profession con thành công.',
  'profession.children_add_failed': 'Thêm profession con thất bại.',
  'profession.add_children_label': 'Thêm profession con:',
  'profession.select_children_placeholder': 'Chọn profession con để thêm',
  'profession.current_children_label': 'Profession con hiện tại:',
  'profession.manage_children_title': 'Quản lý profession con cho: {name}',
  'profession.tree_load_failed': 'Không thể tải cây profession.',
  'profession.services_column': 'Dịch vụ',
  'profession.services_button': 'Dịch vụ',
  'profession.services_load_failed': 'Không thể tải danh sách dịch vụ.',
  'profession.services_available_load_failed':
    'Không thể tải danh sách dịch vụ có thể chọn.',
  'profession.services_remove_select_warning': 'Vui lòng chọn dịch vụ để xoá.',
  'profession.services_remove_success': 'Xoá dịch vụ thành công.',
  'profession.services_remove_failed': 'Xoá dịch vụ thất bại.',
  'profession.services_add_select_warning': 'Vui lòng chọn dịch vụ để thêm.',
  'profession.services_add_success': 'Thêm dịch vụ thành công.',
  'profession.services_add_failed': 'Thêm dịch vụ thất bại.',
  'profession.add_services_label': 'Thêm dịch vụ:',
  'profession.select_services_placeholder': 'Chọn dịch vụ để thêm',
  'profession.current_services_label': 'Dịch vụ hiện tại:',
  'profession.manage_services_title': 'Quản lý dịch vụ cho: {name}',
  'serviceSample.menu_title': 'Service Sample',
  'serviceSample.manager_title': 'Service Sample',
  'serviceSample.title': 'Tiêu đề',
  'serviceSample.description': 'Mô tả',
  'serviceSample.search_placeholder': 'Tìm kiếm theo tiêu đề hoặc mô tả...',
  'serviceSample.fetch_error': 'Không thể tải danh sách service sample.',
  'serviceSample.fetch_detail_failed': 'Không thể tải chi tiết service sample.',
  'serviceSample.update_success': 'Cập nhật thành công!',
  'serviceSample.create_success': 'Tạo thành công!',
  'serviceSample.save_failed': 'Lưu service sample thất bại.',
  'serviceSample.title_required': 'Vui lòng nhập tiêu đề',
  'serviceSample.add_title': 'Thêm Service Sample',
  'serviceSample.edit_title': 'Chỉnh sửa Service Sample',
  'healthSolution.menu_title': 'Thư viện Giải pháp Sức khỏe',
  'libraryCategory.menu_title': 'Phân loại Thư viện',
  'healthSolution.filter_library_category': 'Lọc theo phân loại',
  'healthSolution.library_categories': 'Phân loại',
  'libraryCategory.manager_title': 'Phân loại Thư viện',
  'healthSolution.manager_title': 'Thư viện Giải pháp Sức khỏe',
  'healthSolution.title': 'Tiêu đề',
  'healthSolution.method': 'Cách thực hiện & Công nghệ/Kỹ thuật',
  'healthSolution.applicable_when': 'Áp dụng khi',
  'healthSolution.expected_result': 'Kết quả kỳ vọng',
  'healthSolution.notes': 'Lưu ý',
  'healthSolution.hashtags': 'Hashtag',
  'healthSolution.hashtags_placeholder': 'Nhập tag rồi nhấn Enter',
  'healthSolution.categories': 'Danh mục',
  'healthSolution.categories_placeholder': 'Chọn danh mục',
  'healthSolution.request_template': 'Mẫu Request',
  'healthSolution.offer_template': 'Mẫu Offer',
  'healthSolution.ordering': 'Thứ tự',
  'healthSolution.is_active': 'Kích hoạt',
  'libraryCategory.is_active': 'Hiển thị',
  'libraryCategory.is_active_hint': 'Category bị ẩn sẽ không còn hiện trên Health Library công khai (bộ lọc và nhãn). Các solution vẫn hiển thị.',
  'libraryCategory.filter_status': 'Tất cả trạng thái',
  'libraryCategory.status_visible': 'Đang hiện',
  'libraryCategory.status_hidden': 'Đang ẩn',
  'libraryCategory.status_updated': 'Đã cập nhật trạng thái',
  'libraryCategory.status_failed': 'Cập nhật trạng thái thất bại',
  'healthSolution.filter_status': 'Tất cả trạng thái',
  'healthSolution.status_active': 'Đang hiện',
  'healthSolution.status_hidden': 'Đang ẩn',
  'healthSolution.search_placeholder': 'Tìm theo tiêu đề/cách thực hiện/lưu ý...',
  'healthSolution.filter_category': 'Lọc theo danh mục',
  'healthSolution.import_csv': 'Nhập CSV',
  'healthSolution.download_template': 'Mẫu CSV',
  'healthSolution.import_result': 'Kết quả nhập',
  'healthSolution.import_created': 'Đã tạo',
  'healthSolution.import_failed': 'Thất bại',
  'healthSolution.import_failed_msg': 'Nhập CSV thất bại.',
  'healthSolution.status_failed': 'Cập nhật trạng thái thất bại.',
  'healthSolution.fetch_error': 'Không thể tải danh sách giải pháp sức khỏe.',
  'healthSolution.fetch_detail_failed': 'Không thể tải chi tiết giải pháp sức khỏe.',
  'healthSolution.update_success': 'Cập nhật thành công!',
  'healthSolution.create_success': 'Tạo thành công!',
  'healthSolution.save_failed': 'Lưu giải pháp sức khỏe thất bại.',
  'healthSolution.title_required': 'Vui lòng nhập tiêu đề',
  'healthSolution.add_title': 'Thêm Giải pháp Sức khỏe',
  'healthSolution.edit_title': 'Chỉnh sửa Giải pháp Sức khỏe',
  'global.reporter': 'Người báo cáo',
  'global.reporter_id': 'ID Người báo cáo',
  'global.post_id': 'ID Bài viết',
  'global.resolved': 'Đã xử lý',
  'global.copy_success': 'Sao chép thành công',
  'global.copy_failed': 'Không thể sao chép',
  'global.load_data_failed': 'Lỗi tải dữ liệu',
  'global.select_reporter': 'Chọn người báo cáo',
  'global.select_post': 'Chọn bài viết',
  'global.enter_report_type': 'Nhập loại báo cáo',
  'global.enter_report_content': 'Nhập nội dung báo cáo',
  'global.enter_image_urls': 'Nhập URL hình ảnh cách nhau bởi dấu phẩy',
  'global.enter_image_urls_example':
    'Nhập URL hình ảnh cách nhau bởi dấu phẩy (ví dụ: https://example.com/image1.jpg, https://example.com/image2.jpg)',
  'global.report_not_found': 'Không tìm thấy dữ liệu báo cáo',
  'global.na': 'N/A',
  'global.select_status': 'Chọn trạng thái',
  'global.delete_failed': 'Lỗi xóa',
  'global.pending': 'Đang chờ',
  'global.rejected': 'Từ chối',
  'global.max_30_chars': 'Tối đa 30 ký tự',
  'global.click_to_copy': 'Nhấn để sao chép',
  'dashboard.care_team_ratio': 'Tổng user có care team / tổng user hệ thống',
  'dashboard.care_team_ratio_hint':
    'Tạm thời hiển thị 0 cho đến khi có dữ liệu care team.',
  'dashboard.buyers_with_interests': 'Người mua có sở thích / Tổng người dùng',
  'dashboard.buyers_with_interests_hint':
    'Hiển thị số lượng người mua đã chọn sở thích.',
  'dashboard.buyers_with_interests_percent':
    'Tỷ lệ người mua có sở thích: {percent}%',

  'notification_all.modal.view_title': 'Xem thông báo',
  'notification_all.modal.add_title': 'Gửi thông báo mới',
  'notification_all.select_users': 'Chọn người dùng',
  'notification_all.select_users_placeholder': 'Tìm theo tên hoặc email',
  'notification_all.select_users_required':
    'Vui lòng chọn ít nhất một người dùng',
  'notification_all.channels': 'Kênh thông báo',
  'notification_all.template_key': 'Mã mẫu',
  'notification_all.schedule_time': 'Thời gian gửi',
  'notification_all.schedule_time_placeholder':
    'Chọn thời gian gửi (không bắt buộc)',
  'notification_all.send_to_active_only': 'Chỉ gửi cho người dùng hoạt động',
  'notification_all.last_login_range': 'Khoảng thời gian đăng nhập',
  'notification_all.last_login_range_tooltip': 'Lọc người dùng đã đăng nhập trong khoảng thời gian này (không bắt buộc)',
  'notification_all.last_login_from': 'Từ ngày',
  'notification_all.last_login_to': 'Đến ngày',
  'notification_all.select_all_filtered': 'Chọn tất cả {count} người dùng đã lọc',
  'notification_all.deselect_all_filtered': 'Bỏ chọn tất cả {count} người dùng',
  'notification_all.all_filtered_selected':
    'Đã chọn tất cả {count} người dùng đã lọc. Thông báo sẽ được gửi theo từng batch.',
  'notification_all.filtered_preview_hint':
    'Dropdown đang hiển thị {shown}/{total} người dùng khớp bộ lọc. Dùng Chọn tất cả để gửi cho toàn bộ danh sách.',
  'notification_all.batch_size': 'Số user mỗi batch',
  'notification_all.batch_size_tooltip':
    'Số người dùng gửi mỗi lần (nên để 10–20 để tránh quá tải hệ thống)',
  'notification_all.last_login_range_required':
    'Vui lòng chọn khoảng thời gian đăng nhập để gửi cho tất cả người dùng đã lọc',
  'notification_all.send_notification_button': 'Gửi thông báo',
  'notification_all.reset_button': 'Đặt lại',
  'notification_all.fetch_notification_error':
    'Không thể tải chi tiết thông báo',
  'notification_all.fetch_users_error': 'Không thể tải danh sách người dùng',
  'notification_all.variables_invalid': 'Dữ liệu phải đúng định dạng JSON',
  'notification_all.send_success':
    'Gửi thông báo thành công tới {count} người dùng!',
  'notification_all.send_success_batched':
    'Đã xếp hàng gửi cho {count} người dùng trong {batches} batch (tối đa {batchSize} user/batch).',
  'notification_all.sending_in_progress':
    'Đang gửi thông báo nền cho {count} người dùng...',
  'notification_all.send_error': 'Gửi thông báo thất bại',
  'notification_all.no_users_found': 'Không tìm thấy người dùng',
  'notification_all.title_required': 'Vui lòng nhập tiêu đề thông báo',
  'notification_all.message_required': 'Vui lòng nhập nội dung thông báo',
  'notification_all.all_users': 'Tất cả người dùng',
  'notification_all.active_only': 'Chỉ người dùng hoạt động',
  'chat.chat_information': 'Thông tin chat',
  'chat.members': 'thành viên',
  'chat.failed_to_load_messages': 'Không thể tải tin nhắn',
  'chat.message_deleted_successfully': 'Xóa tin nhắn thành công',
  'chat.delete_message_failed': 'Xóa tin nhắn thất bại',
  'global.unknown': 'Không xác định',
  'global.caption': 'Chú thích',
  'global.author': 'Tác giả',
  'global.audio': 'Âm thanh',
  'global.visibility': 'Hiển thị',
  'global.replies_count': 'Số phản hồi',
  'global.play_count': 'Số lượt phát',
  'global.voice_posts': 'Bài đăng giọng nói',
  'global.replies': 'Phản hồi',
  'global.plays': 'Lượt phát',
  'global.likes': 'Lượt thích',
  'global.shares': 'Lượt chia sẻ',
  'global.hashtag': 'Hashtag',
  'global.user_follows': 'User Follow',
  'global.follower_count': 'Lượt follow',
  'global.following_count': 'Đang follow',
  'voice_posts.search_author_placeholder': 'Tìm kiếm theo tiêu đề, caption, tác giả',
  'voice_posts.post_source_user': 'Bài của người dùng',
  'voice_posts.post_source_system': 'Bài của hệ thống',
  'voice_posts.fake_comment_templates': 'Seeding Comment Template',
  'voice_posts.add_fake_comment_template': 'Thêm mẫu',
  'voice_posts.edit_fake_comment_template': 'Sửa mẫu',
  'voice_posts.fake_comment_template_create_success': 'Tạo mẫu thành công',
  'voice_posts.fake_comment_template_update_success': 'Cập nhật mẫu thành công',
  'voice_posts.delete_fake_comment_template_confirm': 'Xóa mẫu comment giả #{id}?',
  'voice_posts.run_fake_comments': 'Chạy seeding comments',
  'voice_posts.fake_comment_random_author_hint': 'Khi chạy seeding, hệ thống random chọn sample % trong số bài chưa có comment (bài đã có reply sẽ bị bỏ qua). Người comment được gán ngẫu nhiên từ user activated. Template chỉ lưu nội dung (text, voice, icon).',
  'voice_posts.fake_comment_hashtags_hint': 'Không bắt buộc. Template ưu tiên bài có ít nhất 1 hashtag trùng (OR). Nếu cả lần chạy không có bài khớp thì fallback như logic cũ.',
  'voice_posts.select_hashtags': 'Chọn hashtag (không bắt buộc)',
  'voice_posts.fake_comments_success': 'Tạo seeding comments thành công',
  'voice_posts.fake_comments_failed': 'Tạo seeding comments thất bại',
  'voice_posts.min_comments': 'Số comment tối thiểu mỗi bài',
  'voice_posts.max_comments': 'Số comment tối đa mỗi bài',
  'voice_posts.sample_percent': 'Tỷ lệ bài được seeding (%)',
  'voice_posts.random_lang_percent': 'Tỷ lệ bài dùng template random (%)',
  'voice_posts.matching_lang_percent_hint': 'Phần còn lại ({percent}%) sẽ dùng template đúng ngôn ngữ',
  'voice_posts.random_lang_percent_rule': 'Không được lớn hơn tỷ lệ tổng bài seeding',
  'voice_posts.estimated_matching_lang_selected': 'Ước tính bài khớp lang',
  'voice_posts.estimated_random_lang_selected': 'Ước tính bài random lang',
  'voice_posts.post_ids_optional': 'Post ID (tùy chọn, cách nhau bởi dấu phẩy)',
  'voice_posts.seeding_time_range': 'Khoảng thời gian bài voice',
  'voice_posts.seeding_time_range_required': 'Vui lòng chọn khoảng thời gian',
  'voice_posts.author_id_optional': 'Author ID (tùy chọn)',
  'voice_posts.preview_seeding_posts': 'Xem trước danh sách bài',
  'voice_posts.preview_seeding_failed': 'Không tải được danh sách xem trước',
  'voice_posts.total_posts_in_range': 'Tổng bài trong khoảng',
  'voice_posts.posts_already_commented': 'Đã có comment',
  'voice_posts.posts_available': 'Chưa có comment (pool seeding)',
  'voice_posts.posts_matching_lang': 'Khớp template theo ngôn ngữ',
  'voice_posts.posts_fallback_random': 'Dùng template random',
  'voice_posts.estimated_selected': 'Ước tính bài được chọn',
  'voice_posts.estimated_matching_lang': 'Ước tính khớp lang / random',
  'voice_posts.estimated_lang_breakdown_hint': 'khớp lang / random trong số bài ước tính',
  'voice_posts.template_lang_matched': 'Template theo ngôn ngữ',
  'voice_posts.template_lang_matched_yes': 'Khớp lang',
  'voice_posts.template_lang_fallback': 'Random pool',
  'voice_posts.seeding_run_summary': 'Kết quả chạy seeding',
  'voice_posts.posts_selected': 'Bài được chọn',
  'voice_posts.comments_created': 'Comment đã tạo',
  'voice_posts.emoji_or_text': 'Emoji hoặc text',
  'voice_posts.audio_id_required': 'Audio ID bắt buộc với loại voice',
  'voice_posts.image_urls_required': 'Cần ít nhất một URL ảnh',
  'voice_posts.one_url_per_line': 'Mỗi URL một dòng',
  'voice_posts.author_id_required': 'Cần Author ID để upload audio',
  'voice_posts.author_id_upload_hint': 'Bắt buộc khi upload audio mới',
  'voice_posts.audio_upload_failed': 'Upload audio thất bại',
  'voice_posts.image_upload_failed': 'Upload ảnh thất bại',
  'voice_posts.emoji_or_image_required': 'Cần emoji/text hoặc ảnh cho loại icon',
  'voice_posts.analytics_title': 'Thống kê Voice',
  'voice_posts.analytics_back_to_posts': 'Quay lại Voice Posts',
  'voice_home_widgets.title': 'Widget Home Voice',
  'voice_home_widgets.back_to_posts': 'Quay lại Voice Posts',
  'voice_home_widgets.seed': 'Seed mặc định',
  'voice_home_widgets.hint':
    'Widget được chèn vào feed Voice Home sau voice_post thứ N. Flutter chỉ render đúng thứ tự API trả về.',
  'voice_home_widgets.preview': 'Thứ tự xem trước:',
  'voice_home_widgets.widget_type': 'Widget',
  'voice_home_widgets.enabled': 'Bật',
  'voice_home_widgets.position': 'Sau post thứ',
  'voice_home_widgets.position_hint':
    'Chèn widget sau đúng số voice_post này trong session feed',
  'voice_home_widgets.priority': 'Độ ưu tiên',
  'voice_home_widgets.priority_hint':
    'Cao hơn thắng khi hai widget cùng position',
  'voice_home_widgets.repeatable': 'Lặp lại',
  'voice_home_widgets.payload_limit': 'Số item trong widget',
  'voice_home_widgets.extra': 'Extra JSON',
  'voice_home_widgets.extra_hint':
    'Cho strongbody_discovery: title, subtitle, image_url, cta_url, cta_label',
  'voice_home_widgets.edit': 'Sửa widget',
  'voice_home_widgets.load_failed': 'Không tải được Voice Home widgets',
  'voice_home_widgets.update_success': 'Đã cập nhật widget',
  'voice_home_widgets.update_failed': 'Cập nhật thất bại',
  'voice_home_widgets.seed_created': 'Đã seed widget mặc định',
  'voice_home_widgets.seed_exists': 'Widget đã tồn tại',
  'voice_home_widgets.seed_failed': 'Seed thất bại',
  'voice_home_widgets.invalid_extra_json': 'extra phải là JSON hợp lệ',
  'voice_posts.analytics_load_failed': 'Không tải được thống kê voice',
  'voice_posts.analytics_range_hint': 'Thống kê theo khoảng thời gian đã chọn. Voice phổ biến dùng tổng lượt nghe all-time (>50).',
  'voice_posts.analytics_date': 'Ngày',
  'voice_posts.analytics_total_replies': 'Reply',
  'voice_posts.analytics_total_plays': 'Lượt nghe',
  'voice_posts.analytics_author': 'Tác giả',
  'voice_posts.analytics_topic': 'Chủ đề',
  'voice_posts.analytics_play_count': 'Lượt nghe',
  'voice_posts.analytics_post_count': 'Số bài',
  'voice_posts.analytics_avg_duration': 'Độ dài TB',
  'voice_posts.analytics_note': 'Ghi chú',
  'voice_posts.analytics_admin_posted': 'Admin đăng hộ',
  'voice_posts.analytics_uncategorized': 'Chưa phân loại',
  'voice_posts.analytics_retention_ratio': 'Tỷ lệ retention',
  'voice_posts.analytics_avg_post_duration': 'Độ dài bài TB',
  'voice_posts.analytics_popular_count': 'Voice phổ biến (>50 lượt nghe)',
  'voice_posts.analytics_daily_activity': 'Reply & lượt nghe theo ngày',
  'voice_posts.analytics_popular_voices': 'Voice phổ biến',
  'voice_posts.analytics_popular_voices_hint': 'All-time, >50 lượt nghe hợp lệ',
  'voice_posts.analytics_listens_by_country': 'Lượt nghe theo quốc gia',
  'voice_posts.analytics_listens_by_topic': 'Lượt nghe theo chủ đề',
  'voice_posts.analytics_frequent_posters': 'Người đăng thường xuyên (>2 bài)',
  'voice_posts.no_speech_title': 'Bài không có text',
  'voice_posts.no_speech_hint_title': 'Bài có text STT quá ngắn hoặc trống',
  'voice_posts.no_speech_hint':
    'Text STT',
  'voice_posts.no_speech_scan': 'Quét kho cũ',
  'voice_posts.no_speech_scan_confirm_title': 'Quét bài kiểm tra speech?',
  'voice_posts.no_speech_scan_confirm_content':
    'Chạy STT cho các bài pending trong khoảng đã chọn (mặc định 15 ngày gần nhất). Bài đã check sẽ bị bỏ qua trừ khi rescan.',
  'voice_posts.no_speech_scan_success': 'Quét xong',
  'voice_posts.no_speech_scan_failed': 'Quét thất bại',
  'voice_posts.no_speech_scan_result': 'Kết quả quét',
  'voice_posts.no_speech_scanned': 'Đã quét',
  'voice_posts.no_speech_remaining': 'Còn lại',
  'voice_posts.no_speech_min_chars': 'Ngưỡng ký tự',
  'voice_posts.no_speech_confirm_hide': 'Confirm → Draft',
  'voice_posts.no_speech_hide_confirm_title': 'Ẩn các bài đã chọn thành draft?',
  'voice_posts.no_speech_hide_confirm_content':
    'Xác nhận {count} bài no-speech. Các bài sẽ chuyển sang draft và ẩn khỏi feed public.',
  'voice_posts.no_speech_hide_success': 'Đã ẩn {count} bài thành draft',
  'voice_posts.no_speech_hide_failed': 'Ẩn bài thành draft thất bại',
  'voice_posts.no_speech_load_failed': 'Không tải được danh sách bài no-speech',
  'voice_posts.no_speech_empty': 'Không có bài bị đánh dấu trong khoảng này',
  'voice_posts.no_speech_by_day': 'Theo ngày',
  'voice_posts.no_speech_all_days': 'Tất cả ngày',
  'voice_posts.no_speech_filter_by_day': 'Lọc theo ngày',
  'voice_posts.no_speech_stt_text': 'Text STT',
  'voice_posts.no_speech_empty_text': 'Trống',
  'voice_posts.no_speech_status': 'Speech check',
  'voice_posts.no_speech_note': 'Ghi chú',
  'voice_posts.no_speech_status_no_speech': 'Không có speech',
  'voice_posts.no_speech_status_pending': 'Chờ check',
  'voice_posts.no_speech_status_has_speech': 'Có speech',
  'voice_posts.no_speech_status_failed': 'Lỗi',
  'voice_posts.no_speech_status_all': 'Tất cả trạng thái',
  'voice_posts.no_speech_status_unknown': 'Không rõ',
  'global.language_required': 'Ngôn ngữ là bắt buộc',
  'global.filter_by_language': 'Lọc theo ngôn ngữ',
  'global.filter_by_country': 'Lọc theo quốc gia tác giả',
  'global.filter_by_post_source': 'Lọc theo nguồn bài đăng',
  'global.run': 'Chạy',
  'global.optional': 'Tùy chọn',
  'global.edit_profession': 'Chỉnh sửa nghề nghiệp',
  'global.add_profession': 'Thêm nghề nghiệp',
  'global.basic_info': 'Thông tin cơ bản',
  'global.profession_manager': 'Quản lý nghề nghiệp',
  'global.please_input_profession_name': 'Vui lòng nhập tên nghề nghiệp',
  'profession.add_children_hint':
    'Chọn nghề nghiệp để thêm làm con. Chỉ có thể thêm các nghề nghiệp không có con.',
  'profession.save_first_children':
    'Chọn con và nhấn Lưu để tạo nghề nghiệp với con',
  'profession.children_save_hint':
    'Chọn con ở trên và nhấn Lưu để áp dụng thay đổi',
  'profession.no_children': 'Chưa có con nào được thêm',
  'profession.add_services_hint':
    'Chọn mẫu dịch vụ để liên kết với nghề nghiệp này.',
  'profession.save_first_services':
    'Chọn dịch vụ và nhấn Lưu để tạo nghề nghiệp với dịch vụ',
  'profession.services_save_hint':
    'Chọn dịch vụ ở trên và nhấn Lưu để áp dụng thay đổi',
  'profession.no_services': 'Chưa có dịch vụ nào được thêm',
  'profession.children_count':
    '{count, plural, =0 {Không có con} =1 {1 con} other {# con}}',
  'profession.services_count':
    '{count, plural, =0 {Không có dịch vụ} =1 {1 dịch vụ} other {# dịch vụ}}',
  'global.edit_interest': 'Chỉnh sửa sở thích',
  'global.add_interest': 'Thêm sở thích',
  'global.interest_manager': 'Quản lý sở thích',
  'global.interest_saved': 'Lưu sở thích thành công',
  'global.failed_to_save_interest': 'Lưu sở thích thất bại',
  'global.slug_already_exists': 'Slug đã tồn tại',
  'global.slug_already_exists_message':
    'Slug này đã được sử dụng bởi một bài viết khác. Vui lòng chọn slug khác.',
  'global.slug_auto_generate_tooltip':
    'Slug được tự động tạo từ câu hỏi, nhưng bạn có thể chỉnh sửa nếu cần',
  'global.slug_auto_generate_placeholder':
    'Slug sẽ được tự động tạo từ câu hỏi',
  'global.please_input_interest_name': 'Vui lòng nhập tên sở thích',
  'interest.add_children_hint':
    'Chọn sở thích để thêm làm con. Chỉ có thể thêm các sở thích lá.',
  'interest.save_first_children': 'Lưu sở thích trước để thêm con',
  'interest.children_save_hint':
    'Chọn con ở trên và nhấn Lưu để áp dụng thay đổi',
  'interest.no_children': 'Chưa có con nào được thêm',
  'interest.professions_tab': 'Nghề nghiệp',
  'interest.add_professions_hint':
    'Chọn nghề nghiệp để liên kết với sở thích này.',
  'interest.save_first_professions': 'Lưu sở thích trước để thêm nghề nghiệp',
  'interest.professions_save_hint':
    'Chọn nghề nghiệp ở trên và nhấn Lưu để áp dụng thay đổi',
  'interest.no_professions': 'Chưa có nghề nghiệp nào được thêm',
  'interest.children_count':
    '{count, plural, =0 {Không có con} =1 {1 con} other {# con}}',
  'interest.professions_count':
    '{count, plural, =0 {Không có nghề nghiệp} =1 {1 nghề nghiệp} other {# nghề nghiệp}}',
  'dashboard.daily_overview': 'Tổng quan trong ngày',
  'daily_report.total_seller_hr': 'Tổng HR Freelance',
  'daily_report.total_seller_sale_voice': 'Tổng Sale Voice',
  'daily_report.total_seller_sale_shop_active': 'Tổng Sale Product',
  'daily_report.total_seller_sale_buy_website': 'Tổng Sale Buy Website',
  'daily_report.total_seller_sale_profile': 'Tổng Sale Profile',
  'daily_report.total_seller_edu': 'Tổng Edu',
  'daily_report.total_seller_other': 'Tổng Partner',
  'daily_report.new_seller_hr_daily': 'HR Freelance mới',
  'daily_report.new_seller_sale_voice_daily': 'Sale Voice mới',
  'daily_report.new_seller_sale_shop_active_daily': 'Sale Product mới',
  'daily_report.new_seller_sale_buy_website_daily': 'Sale Buy Website mới',
  'daily_report.new_seller_sale_profile_daily': 'Sale Profile mới',
  'daily_report.new_seller_edu_daily': 'Edu mới',
  'daily_report.new_seller_other_daily': 'Partner mới',
  'daily_report.title': 'Báo cáo ngày',
  'daily_report.load_failed': 'Không thể tải báo cáo ngày',
  'daily_report.user_statistics': 'Thống kê người dùng',
  'daily_report.section_seller': 'Seller',
  'daily_report.section_seller_desc':
    'Người bán trên hệ thống, chia theo kênh Sale (bán hàng) và HR (tuyển dụng)',
  'daily_report.section_user': 'User',
  'daily_report.section_user_desc':
    'User mới được chia theo kênh đăng ký: Web và Mobile (Android + iOS)',
  'daily_report.all_time_badge': 'Tích lũy',
  'daily_report.section_content_activity': 'Dịch vụ & Hoạt động',
  'daily_report.section_content_activity_desc':
    'Dịch vụ, sản phẩm, voice và request trong khoảng ngày đã chọn',
  'daily_report.new_users_formula': 'User mới = Web + Mobile (Android + iOS)',
  'daily_report.total_sellers_formula': 'Tổng seller = Sale + HR',
  'daily_report.new_sellers_formula': 'Seller mới = Sale + HR',
  'daily_report.section_campaign': 'Chiến dịch affiliate',
  'daily_report.section_campaign_desc':
    'User tham gia, đăng ký và click theo từng chiến dịch trong khoảng ngày',
  'daily_report.campaign_filter_range': 'Khoảng ngày lọc',
  'daily_report.campaign_col_name': 'Chiến dịch',
  'daily_report.campaign_col_users': 'User',
  'daily_report.campaign_col_signups': 'Đăng ký',
  'daily_report.campaign_col_clicks': 'Click',
  'daily_report.campaign_summary_users': 'User tham gia chiến dịch',
  'daily_report.campaign_summary_signups': 'Đăng ký qua chiến dịch',
  'daily_report.campaign_summary_clicks': 'Click qua chiến dịch',
  'daily_report.google_ads_title': 'Google Ads — Báo cáo ngày',
  'google_ads.campaigns': 'Chiến dịch',
  'google_ads.cost_report': 'Báo cáo chi phí',
  'google_ads.daily_report': 'Báo cáo ngày',
  'google_ads.install_report': 'Báo cáo cài đặt',
  'google_ads.notes_title': 'Ghi chú giải thích các thông số báo cáo',
  'google_ads.cost': 'Chi phí quảng cáo',
  'google_ads.clicks': 'Số lượt nhấp',
  'google_ads.impressions': 'Số lượt hiển thị',
  'google_ads.conversions': 'Số lượt chuyển đổi',
  'google_ads.ctr': 'Tỷ lệ nhấp (CTR)',
  'google_ads.avg_cpc': 'CPC TB',
  'google_ads.all_conversions': 'Tổng chuyển đổi (gồm phụ)',
  'google_ads.install': 'Cài đặt ứng dụng',
  'google_ads.first_open': 'Mở lần đầu',
  'google_ads.cost_per_conversion': 'Chi phí/chuyển đổi (CPA)',
  'google_ads.conversion_rate': 'Tỷ lệ chuyển đổi',
  'google_ads.status': 'Trạng thái',
  'google_ads.no_data': 'Không có dữ liệu trong khoảng thời gian đã chọn.',
  'google_ads.campaign': 'Chiến dịch',
  'google_ads.account_id': 'ID Tài khoản',
  'google_ads.campaign_id': 'ID CD',
  'appsflyer.organic_app_button': 'Organic tải app',
  'appsflyer.organic_app_title': 'Báo cáo lượt cài app AppsFlyer',
  'appsflyer.media_source_button': 'Hiệu quả media source',
  'appsflyer.media_source_title': 'Hiệu quả media source AppsFlyer',
  'appsflyer.report_button': 'Báo cáo cài app tổng hợp',
  'appsflyer.report_title': 'Báo cáo cài app tổng hợp AppsFlyer',
  'appsflyer.load_failed': 'Không tải được báo cáo AppsFlyer',
  'appsflyer.notes_title': 'API AppsFlyer',
  'appsflyer.organic_installs_desc': 'Dùng /v1/appsflyer/report. Hiển thị organic installs, total installs, clicks và media sources. Response AppsFlyer không có impressions.',
  'appsflyer.media_source_desc': 'Clicks và installs được nhóm theo media_source/campaign từ AppsFlyer.',
  'appsflyer.report_desc': 'API tổng hợp: organic_installs và campaign_performance từ AppsFlyer.',
  'appsflyer.organic_installs': 'Organic installs',
  'appsflyer.total_installs': 'Total installs',
  'appsflyer.organic_installs_array': 'Organic installs theo platform/app/ngày',
  'appsflyer.campaign_performance': 'Danh sách hiệu quả campaign',
  'appsflyer.clicks': 'Clicks',
  'appsflyer.media_sources': 'Media sources',
  'appsflyer.media_source': 'Media source',
  'appsflyer.campaign': 'Chiến dịch',
  'appsflyer.platform': 'Nền tảng',
  'appsflyer.app_id': 'App ID',
  'appsflyer.installs': 'Installs',
  'appsflyer.date': 'Ngày',
  'appsflyer.no_data': 'Không có dữ liệu Appsflyer',
  'appsflyer.no_data_desc': 'Thử chọn khoảng ngày khác hoặc kiểm tra cron đồng bộ Appsflyer.',
  'daily_report.section_downloads': 'Lượt tải & đăng ký app',
  'daily_report.section_downloads_desc':
    'Số lượt đăng ký / tải app theo từng nền tảng',
  'daily_report.section_mobile': 'Mobile',
  'daily_report.section_mobile_desc':
    'Tổng Mobile = Android + iOS (trong khoảng ngày đã chọn)',
  'daily_report.section_web_signups': 'Sign-up via Web',
  'daily_report.section_web_signups_desc':
    'Đăng ký web, chuyển đổi affiliate và link mời trong khoảng ngày đã chọn',
  'daily_report.section_service': 'Service',
  'daily_report.section_product': 'Product',
  'daily_report.section_voice': 'Voice',
  'daily_report.section_voice_desc': 'Bài đăng Voice — tin nhanh trên app',
  'daily_report.section_request': 'Request',
  'daily_report.section_request_desc':
    'Yêu cầu tìm seller do user hoặc vận hành tạo',
  'daily_report.context_range': 'Đang xem: {from} → {to}',
  'daily_report.context_no_range':
    'Chưa chọn khoảng ngày — chọn ngày góc phải để lọc số liệu',
  'daily_report.reading_guide':
    '「Tổng tích lũy」= không đổi khi lọc ngày. User mới = Web + Mobile; Mobile = Android + iOS.',
  'daily_report.row_all_time': 'Tổng tích lũy — không phụ thuộc bộ lọc ngày',
  'daily_report.row_in_period': 'Trong khoảng ngày đã chọn',
  'daily_report.row_mobile_breakdown': 'Chi tiết theo nền tảng',
  'daily_report.row_web_signups': 'Đăng ký qua Web',
  'daily_report.row_affiliate_signups': 'Affiliate & link mời',
  'daily_report.hint_all_time': 'Tích lũy từ trước đến nay',
  'daily_report.hint_in_period': 'Theo ngày đã lọc phía trên',
  'daily_report.data_calculation_note':
    '* Dữ liệu được tính từ 6h sáng ngày hôm trước đến 6h sáng ngày hôm sau (theo giờ Việt Nam)',
  'daily_report.total_users': 'Tổng người dùng',
  'daily_report.all_time': 'Tích lũy',
  'daily_report.new_users_daily': 'User mới',
  'daily_report.signup_android': 'Đăng ký Android',
  'daily_report.signup_ios': 'Đăng ký iOS',
  'daily_report.in_selected_period': 'Theo lọc',
  'daily_report.total_sellers': 'Tổng người bán',
  'daily_report.new_sellers_daily': 'Seller mới',
  'daily_report.service_product_statistics': 'Dịch vụ & Sản phẩm',
  'daily_report.service_product_statistics_desc':
    'Dịch vụ và sản phẩm mà seller đăng bán trên app',
  'daily_report.total_services': 'Tổng dịch vụ đang bán',
  'daily_report.new_services_daily': 'Dịch vụ mới đăng',
  'daily_report.total_products': 'Tổng sản phẩm đang bán',
  'daily_report.new_products_daily': 'Sản phẩm mới đăng',
  'daily_report.voice_statistics': 'Thống kê Voice',
  'daily_report.total_voice_posts': 'Tổng bài Voice',
  'daily_report.new_voice_posts_daily': 'Voice mới',
  'daily_report.new_voice_posts_by_user_daily': 'Voice do user đăng',
  'daily_report.new_voice_posts_by_owner_daily': 'Voice do vận hành đăng hộ',
  'daily_report.total_voice_comments': 'Tổng comment',
  'daily_report.new_voice_comments_daily': 'Comment mới',
  'daily_report.total_voice_likes': 'Tổng lượt thích',
  'daily_report.new_voice_likes_daily': 'Lượt thích mới',
  'daily_report.total_voice_shares': 'Tổng lượt chia sẻ',
  'daily_report.total_voice_listens': 'Tổng lượt nghe',
  'daily_report.new_voice_listens_daily': 'Lượt nghe mới',
  'daily_report.request_statistics': 'Thống kê Request',
  'daily_report.total_requests': 'Tổng request',
  'daily_report.new_requests': 'Request mới',
  'daily_report.requests_by_user': 'Request do user tạo',
  'daily_report.requests_by_staff': 'Request do vận hành tạo hộ',
  'daily_report.aff_conversion_statistics': 'Thống kê chuyển đổi affiliate',
  'daily_report.signup_web': 'Đăng ký qua Web',
  'daily_report.signup_mobile': 'Tải app (Android + iOS)',
  'daily_report.aff_total_signup_conversions': 'Nhận lời mời đăng ký qua web',
  'daily_report.app_signups_via_invitation': 'Nhận lời mời đăng ký qua app',
  'daily_report.payment_type_user_subscription': 'Thanh toán gói user',
  'daily_report.payment_type_user_subscription_desc':
    'Giao dịch thanh toán gói đăng ký của người dùng',
  'daily_report.payment_type_offer': 'Thanh toán Offer',
  'daily_report.payment_type_offer_desc':
    'Giao dịch thanh toán từ offer / chào giá',
  'daily_report.total_payments': 'Tổng giao dịch',
  'daily_report.successful_count': 'Giao dịch thành công',
  'daily_report.failed_count': 'Giao dịch thất bại',
  'daily_report.new_payments_daily': 'Giao dịch mới hôm nay',
  'daily_report.total_amount_daily': 'Tiền thu hôm nay',
  'daily_report.total_amount': 'Tổng tiền tích lũy',
  'daily_report.success_rate': 'Tỷ lệ thành công',
  'daily_report.success_failed_count':
    '{successful} thành công / {failed} thất bại',
  'daily_report.new_users_exclude_vn': 'Tổng user mới trừ nước Việt Nam',
  'daily_report.new_sellers_exclude_vn': 'Tổng seller mới trừ VN',

  // Categories
  'categories.interest': 'Sở thích',
  'categories.product_count': 'Số lượng sản phẩm',
  'categories.service_count': 'Số lượng dịch vụ',
  'categories.reorder_categories': 'Sắp xếp lại danh mục',
  'categories.save_order': 'Lưu thứ tự',
  'categories.loading_categories': 'Đang tải danh mục...',
  'categories.order_label': 'Thứ tự',
  'categories.failed_to_load_categories_for_ordering':
    'Không thể tải danh mục để sắp xếp',
  'categories.order_updated_successfully': 'Cập nhật thứ tự thành công',
  'categories.failed_to_update_order': 'Không thể cập nhật thứ tự',
  'categories.depth': 'Độ sâu',
  'categories.id_label': 'ID',

  // LDP Inquiries
  'ldp_inquiries.title': 'LDP Inquiries',
  'ldp_inquiries.get_all': 'Lấy tất cả',
  'ldp_inquiries.full_name': 'Họ và tên',
  'ldp_inquiries.area': 'Khu vực',
  'ldp_inquiries.work_preference': 'Sở thích làm việc',
  'ldp_inquiries.contact_request': 'Yêu cầu liên hệ',
  'ldp_inquiries.phone': 'Điện thoại',
  'ldp_inquiries.scope': 'Phạm vi',
  'ldp_inquiries.scope_admin_dashboard': 'Admin Dashboard',
  'ldp_inquiries.scope_network': 'Mạng',
  'ldp_inquiries.scope_local': 'Địa phương',
  'ldp_inquiries.no_data_to_export': 'Không có dữ liệu để xuất',
  'ldp_inquiries.exported_successfully': 'Đã xuất {count} bản ghi thành công',
  'ldp_inquiries.api_error': 'API trả về lỗi',
  'ldp_inquiries.fetch_failed': 'Không thể lấy danh sách inquiries',
  'ldp_inquiry_send_emails.title': 'LDP Inquiry Send Emails',
  'ldp_inquiry_send_emails.create_title': 'Tạo email gửi inquiry',
  'ldp_inquiry_send_emails.view_title': 'Chi tiết email inquiry',
  'ldp_inquiry_send_emails.full_name': 'Họ và tên',
  'ldp_inquiry_send_emails.full_name_required': 'Vui lòng nhập họ và tên',
  'ldp_inquiry_send_emails.request': 'Yêu cầu',
  'ldp_inquiry_send_emails.request_required': 'Vui lòng nhập yêu cầu',
  'ldp_inquiry_send_emails.files': 'Tệp đính kèm',
  'ldp_inquiry_send_emails.files_hint': 'Tùy chọn. URL file, cách nhau bởi dấu phẩy',
  'ldp_inquiry_send_emails.fetch_failed': 'Không thể lấy danh sách email inquiry',
  'ldp_inquiry_send_emails.search_placeholder':
    'Tìm theo họ tên hoặc email...',
  'global.affiliate_tier': 'Hạng Affiliate',
  'affiliate.tier_management': 'Quản lý hạng Affiliate',
  'affiliate.add_tier': 'Thêm hạng Affiliate',
  'affiliate.edit_tier': 'Sửa hạng Affiliate',
  'affiliate.min_conversions': 'Chuyển đổi tối thiểu',
  'affiliate.max_conversions': 'Chuyển đổi tối đa',
  'affiliate.commission_rate': 'Tỷ lệ hoa hồng (%)',
  'affiliate.platform_fee_discount': 'Giảm phí nền tảng (%)',
  'affiliate.bonus_amount': 'Số tiền thưởng',
  'affiliate.benefits': 'Quyền lợi',
  'global.add_benefit': 'Thêm quyền lợi',
  'affiliate.conversions': 'Mức chuyển đổi',
  'global.number_of_seeds': 'Số lượng seeds',
  'global.number_of_seeds_required': 'Vui lòng nhập số lượng seeds',
  'global.contact_info': 'Thông tin liên hệ',
  'global.members': 'Thành viên',
  'global.updated_by_users': 'Người cập nhật',
  'global.no_users_found': 'Không tìm thấy người dùng',
  'global.delete_error': 'Lỗi xóa',
  'global.failed_to_load_user_info': 'Không tải được thông tin người dùng',
  'global.click_to_view_updaters_count': 'Xem danh sách {count} người cập nhật',
  'global.click_to_view_updater': 'Xem thông tin người cập nhật',
  'global.owner_email_copied': 'Đã sao chép email chủ sở hữu',
  'global.contact_email_copied': 'Đã sao chép email liên hệ',
  'global.shop_name_name': 'Tên cửa hàng / Tên',
  'global.members_of': 'Thành viên của',
  'global.search_by_email_placeholder': 'Tìm kiếm theo email...',
  'global.email_copied': 'Đã sao chép email',
  'global.add_member': 'Thêm thành viên',
  'global.search_user_placeholder': 'Tìm kiếm theo email, tên...',
  'global.select_seller': 'Chọn người bán',
  'global.no_sellers_found': 'Không tìm thấy người bán',
  'global.select_categories': 'Chọn danh mục',
  'global.enter_description': 'Nhập mô tả...',
  'global.require_certificate_image': 'Vui lòng tải lên ảnh chứng chỉ',
  'global.certificate_saved': 'Lưu chứng chỉ thành công',
  'global.form_validation_failed': 'Vui lòng điền các trường bắt buộc',
  'global.create_success': 'Tạo thành công!',
  'global.update_success': 'Cập nhật thành công!',
  'global.update_error': 'Lỗi cập nhật',
  'global.fetch_failed': 'Lấy dữ liệu thất bại',
  'global.add_success': 'Thêm thành công',
  'global.add_failed': 'Thêm thất bại',
  'global.delete_failed': 'Xóa thất bại',
  'global.iap_enabled': 'Bật IAP',
  'global.apple_product_id': 'Apple Product ID',
  'global.google_product_id': 'Google Product ID',
  'global.stripe_product_id': 'Stripe Product ID',
  'global.stripe_price_id': 'Stripe Price ID',
  'global.please_input_apple_product_id': 'Vui lòng nhập Apple Product ID',
  'global.please_input_google_product_id': 'Vui lòng nhập Google Product ID',
  'global.please_input_stripe_product_id': 'Vui lòng nhập Stripe Product ID',
  'global.please_input_stripe_price_id': 'Vui lòng nhập Stripe Price ID',

  // Dashboard Stats
  'dashboard.admin_dashboard': 'Bảng điều khiển',
  'dashboard.overview': 'Tổng quan',
  'dashboard.voice_engagement': 'Voice & Tương tác',
  'dashboard.engagement': 'Tương tác',
  'dashboard.daily_report': 'Báo cáo hằng ngày',
  'dashboard.days': 'ngày',
  'dashboard.view_all': 'Xem tất cả',
  'dashboard.total': 'Tổng',
  'dashboard.new_users': 'Người dùng mới',
  'dashboard.new_blogs': 'Bài viết mới',
  'dashboard.new_services': 'Dịch vụ mới',
  'dashboard.new_products': 'Sản phẩm mới',
  'dashboard.users_with_conversion': 'có chuyển đổi',
  'dashboard.payment_history_tab': 'Lịch sử thanh toán',
  'global.user_revenue': 'Doanh thu người dùng',
  'global.withdrawals': 'Yêu cầu rút tiền',
  'dashboard.users': 'Người dùng',
  'dashboard.new': 'mới',
  'dashboard.new_sellers': 'Người bán mới',
  'dashboard.sellers': 'Người bán',
  'dashboard.voice': 'Bài Voice',
  'dashboard.active_admins': 'Quản trị viên đang hoạt động',
  'dashboard.online': 'trực tuyến',
  'dashboard.app_downloads': 'Lượt tải App - Đã đăng nhập',
  'dashboard.efficiency': 'Hiệu quả',
  'dashboard.click': 'lượt nhấp',
  'dashboard.new_user': 'người dùng mới',
  'dashboard.finance_overview': 'Tổng quan tài chính',
  'dashboard.total_in_wallet': 'Tổng trong ví',
  'dashboard.pending_disbursement': 'Đang chờ giải ngân',
  'dashboard.publishers': 'Nhà xuất bản',
  'dashboard.content_activity': 'Nội dung & Hoạt động',
  'dashboard.blogs': 'Bài viết',
  'dashboard.services': 'Dịch vụ',
  'dashboard.products': 'Sản phẩm',
  'dashboard.buyers_care_team': 'Đội ngũ chăm sóc người mua',
  'dashboard.buyers_care_team_percent':
    '{percent}% người mua đã đăng ký quan tâm',
  'global.affiliate_tier': 'Cấp bậc tiếp thị',
  'global.affiliate_tier_history': 'Lịch sử cấp bậc',
  'global.affiliate_tier_users': 'Người dùng theo cấp bậc',
  'global.affcampaign': 'Chiến dịch tiếp thị',
  'global.campaignUser': 'Người dùng chiến dịch',
  'global.conversion': 'Chuyển đổi',
  'global.clicks': 'Lượt nhấp',

  // SEO Management
  'sidebar.seo': 'Quản lý SEO',
  'sidebar.seo.locations': 'Địa điểm',
  'sidebar.seo.services': 'Dịch vụ',
  'sidebar.seo.additionalNeeds': 'Nhu cầu bổ sung',
  'sidebar.seo.translations': 'Bản dịch',
  'seo.locations.title': 'Địa điểm SEO',
  'seo.locations.name': 'Tên địa điểm',
  'seo.locations.slug': 'Slug',
  'seo.locations.level': 'Cấp độ',
  'seo.locations.country': 'Quốc gia',
  'seo.locations.parent': 'Địa điểm cha',
  'seo.locations.description': 'Mô tả',
  'seo.locations.latitude': 'Vĩ độ',
  'seo.locations.longitude': 'Kinh độ',
  'seo.locations.status': 'Trạng thái',
  'seo.locations.level.city': 'Thành phố',
  'seo.locations.level.district': 'Quận/Huyện',
  'seo.locations.level.neighborhood': 'Phường/Xã',
  'seo.locations.level.region': 'Vùng',
  'seo.services.title': 'Dịch vụ SEO',
  'seo.services.name': 'Tên dịch vụ',
  'seo.services.slug': 'Slug',
  'seo.services.category': 'Danh mục',
  'seo.services.type': 'Loại',
  'seo.services.type.service': 'Dịch vụ',
  'seo.services.type.expert': 'Chuyên gia',
  'seo.services.icon': 'Biểu tượng',
  'seo.services.description': 'Mô tả',
  'seo.additionalNeeds.title': 'Nhu cầu bổ sung',
  'seo.additionalNeeds.name': 'Tên nhu cầu',
  'seo.additionalNeeds.slug': 'Slug',
  'seo.additionalNeeds.priority': 'Ưu tiên',
  'seo.additionalNeeds.description': 'Mô tả',
  'seo.translations.title': 'Bản dịch dịch vụ SEO',
  'seo.translations.add': 'Thêm bản dịch',
  'seo.translations.edit': 'Chỉnh sửa bản dịch',
  'seo.translations.service': 'Dịch vụ',
  'seo.translations.country': 'Quốc gia',
  'seo.translations.name': 'Tên đã dịch',
  'seo.translations.description': 'Mô tả đã dịch',
  'chat.search_creator_placeholder': 'Tìm email hoặc tên creator',
  'chat.search_creator_hint': 'Tìm theo email, họ hoặc tên creator (phía server).',
  'analyticsReport.menu': 'Traffic Report',
  'analyticsReport.title': 'PostHog Dashboard',
  'analyticsReport.info': 'Bảng chỉ số dùng cho báo cáo admin',
  'analyticsReport.subtitle': 'Tổng hợp số liệu từ PostHog',
  'analyticsReport.lastSync': 'Cập nhật lần cuối',
  'analyticsReport.sync': 'Đồng bộ dữ liệu',
  'analyticsReport.addManual': 'Thêm chỉ số thủ công',
  'analyticsReport.tableTitle': 'Bảng tổng hợp chỉ số',
  'analyticsReport.searchMetric': 'Tìm chỉ số',
  'analyticsReport.reload': 'Tải lại',
  'analyticsReport.refresh': 'Làm mới',
  'analyticsReport.metric': 'Chỉ số',
  'analyticsReport.metricLabel': 'Tên chỉ số',
  'analyticsReport.metricKey': 'Mã chỉ số',
  'analyticsReport.date': 'Ngày',
  'analyticsReport.reportDate': 'Ngày báo cáo',
  'analyticsReport.updatedDate': 'Ngày cập nhật',
  'analyticsReport.currentValue': 'Giá trị hiện tại',
  'analyticsReport.source': 'Nguồn',
  'analyticsReport.platform': 'Nền tảng',
  'analyticsReport.lastUpdated': 'Cập nhật cuối',
  'analyticsReport.updatedBy': 'Cập nhật bởi',
  'analyticsReport.actions': 'Thao tác',
  'analyticsReport.editMetric': 'Sửa chỉ số',
  'analyticsReport.history': 'Lịch sử',
  'analyticsReport.reason': 'Lý do',
  'analyticsReport.time': 'Thời gian',
  'analyticsReport.action': 'Hành động',
  'analyticsReport.previousValue': 'Giá trị trước',
  'analyticsReport.loadFailed': 'Không tải được báo cáo',
  'analyticsReport.historyLoadFailed': 'Không tải được lịch sử',
  'analyticsReport.syncEmpty': 'Không có chỉ số PostHog để đồng bộ',
  'analyticsReport.syncedFromPosthog': 'Đồng bộ từ PostHog',
  'analyticsReport.syncSuccess': 'Đã đồng bộ dữ liệu PostHog',
  'analyticsReport.syncFailed': 'Không đồng bộ được dữ liệu PostHog',
  'analyticsReport.syncWebOnly': 'Đồng bộ PostHog hiện chỉ dùng cho Web',
  'analyticsReport.deletedFromAdmin': 'Xóa từ admin',
  'global.subscribers': 'Subscriber Notification App',
  'global.subscriber_manager': 'Subscriber Notification App Manager',

  // Trang theo dõi nguồn đăng ký
  'trackingPage.menu': 'Nguồn đăng ký (Ads)',
  'trackingPage.manager': 'Nguồn đăng ký',
  'trackingPage.tab.campaign': 'Chiến dịch quảng cáo',
  'trackingPage.tab.page': 'Theo trang',
  'trackingPage.tab.registry': 'Cấu hình trang theo dõi',
  'trackingPage.col.page': 'Trang',
  'trackingPage.col.label': 'Tên hiển thị',
  'trackingPage.col.match': 'Kiểu khớp',
  'trackingPage.col.sort': 'Thứ tự',
  'trackingPage.col.actions': 'Thao tác',
  'trackingPage.col.campaign': 'Campaign',
  'trackingPage.col.source': 'Nguồn',
  'trackingPage.col.signups': 'Lượt đăng ký',
  'trackingPage.col.email': 'Email',
  'trackingPage.col.name': 'Tên',
  'trackingPage.col.registeredAt': 'Thời điểm đăng ký',
  'trackingPage.col.care': 'Chăm sóc',
  'trackingPage.messageUser': 'Nhắn tin cho khách này',
  'trackingPage.openFullChat': 'Mở trang chat đầy đủ',
  'trackingPage.care.none': 'Chưa liên hệ',
  'trackingPage.care.waiting': 'Đang chờ',
  'trackingPage.care.done': 'Đã nhắn',
  'trackingPage.care.none.hint': 'Chưa liên hệ — chưa có hội thoại nào',
  'trackingPage.care.waiting.hint': 'Đang chờ — khách nhắn cuối, cần mình trả lời',
  'trackingPage.care.done.hint': 'Đã nhắn — mình nhắn cuối, chờ khách phản hồi',
  'care.unassigned': 'Chưa ai nhận',
  'care.alreadyContacted': 'Đồng nghiệp đã nhắn khách này',
  'care.viewThread': 'Xem hội thoại',
  'care.backToMine': 'Về hội thoại của tôi',
  'care.readOnlyOf': 'Đang xem hội thoại của {name} — chỉ đọc',
  'care.readFailed': 'Không đọc được hội thoại này',
  'care.noMessages': 'Chưa có tin nhắn nào',
  'care.othersContacted': '{count} người đã nhắn',
  'care.othersWaiting': 'Khách đang chờ {name} trả lời',
  'care.someoneWaiting': 'Khách đang chờ trả lời ở luồng của đồng nghiệp',
  'care.theyReplied': 'đã trả lời',
  'care.customerWaiting': 'chưa trả lời khách',
  'care.currentOwner': 'Đang phụ trách: {name}',
  'care.claim': 'Nhận khách này',
  'care.save': 'Lưu',
  'care.saved': 'Đã lưu',
  'care.saveFailed': 'Không lưu được',
  'care.notePlaceholder': 'Ghi chú cho người tiếp theo: khách hỏi gì, hẹn khi nào, vì sao từ chối…',
  'care.filter.unassigned': 'Chỉ hiện khách chưa ai nhận',
  'trackingPage.col.method': 'Hình thức',
  'trackingPage.col.landing': 'Trang vào',
  'trackingPage.col.registration': 'Trang đăng ký',
  'trackingPage.col.details': 'Chi tiết',
  'trackingPage.col.user': 'Người dùng',
  'trackingPage.col.pages': 'Trang',
  'trackingPage.col.campaignName': 'Tên campaign',
  'trackingPage.dateRange': 'Khoảng ngày',
  'trackingPage.viewSignups': 'Xem người đăng ký',
  'trackingPage.search.user': 'Tìm email hoặc tên',
  'trackingPage.empty.pages': 'Chưa có trang nào',
  'trackingPage.empty.campaigns': 'Chưa có campaign nào',
  'trackingPage.empty.users': 'Chưa có ai đăng ký',
  'trackingPage.col.fromGoogleAds': 'Từ quảng cáo Google',
  'trackingPage.search.registry': 'Tìm theo trang hoặc tên hiển thị',
  'trackingPage.search.campaign': 'Tìm campaign (id / tên)',
  'trackingPage.apply': 'Áp dụng',
  'trackingPage.activeOnly': 'Chỉ trang đang bật',
  'trackingPage.activeOnlyHint': 'Chỉ đếm những trang đang được bật',
  'trackingPage.totalSignups': 'Tổng lượt đăng ký (mọi trang trong danh sách)',
  'trackingPage.fromAds': 'Từ quảng cáo',
  'trackingPage.organic': 'Tự nhiên',
  'trackingPage.organicTag': 'Tự nhiên / Trực tiếp',
  'trackingPage.viewing': 'Đang xem: {range}',
  'trackingPage.allTime': 'Toàn thời gian',
  'trackingPage.rangeHint': 'Lượt đăng ký được cộng dồn theo campaign trong khoảng ngày này.',
  'trackingPage.refresh': 'Tải lại theo bộ lọc hiện tại',
  'trackingPage.preset.7d': '7 ngày gần nhất',
  'trackingPage.preset.30d': '30 ngày gần nhất',
  'trackingPage.preset.thisMonth': 'Tháng này',
  'trackingPage.preset.lastMonth': 'Tháng trước',
  'trackingPage.totalHint': 'Toàn bộ tài khoản tạo trong khoảng ngày này, gồm cả từ quảng cáo lẫn tự nhiên.',
  'trackingPage.fromAdsHint': 'Lượt đăng ký có kèm mã campaign (utm_campaign hoặc lượt click quảng cáo Google).',
  'trackingPage.organicHint': 'Lượt đăng ký không có mã campaign: tìm kiếm, vào thẳng, giới thiệu, hoặc link quảng cáo bị mất tham số theo dõi.',
  'trackingPage.statNoteAllSources': 'Tất cả nguồn',
  'trackingPage.statNoteAllPages': 'Tất cả trang đang theo dõi',
  'trackingPage.statNoteActivePages': 'Chỉ trang đang bật',
  'trackingPage.totalPagesHint': 'Lượt đăng ký có trang vào đầu tiên khớp với một trong các trang liệt kê bên dưới, trong khoảng ngày này.',
  'trackingPage.statNoteShare': 'Chiếm {pct}% lượt đăng ký',
  'trackingPage.signupsColHint': 'Bấm vào con số để xem danh sách tài khoản.',
  'trackingPage.signupsOf': 'Người đăng ký · {name}',
  'trackingPage.noCampaignName': '{id} — chưa có tên, campaign này chưa đồng bộ từ Google Ads',
  'trackingPage.gclidHint': 'Google Click ID — lượt đăng ký này đến từ một cú click quảng cáo Google',
  'trackingPage.yes': 'Có',
  'trackingPage.no': 'Không',
  'trackingPage.deleteRow': 'Xóa trang theo dõi này?',
  'trackingPage.deleteUser': 'Xóa tài khoản này?',
  'trackingPage.deleteUserHint': '{email} sẽ bị xóa (xóa mềm, khôi phục được).',
  'trackingPage.deleteUserDone': 'Đã xóa tài khoản {email}',
  'trackingPage.deleteUserFailed': 'Xóa tài khoản thất bại',
  'trackingPage.saved': 'Đã lưu trang theo dõi',
  'trackingPage.saveFailed': 'Không lưu được trang theo dõi',
  'trackingPage.deleted': 'Đã xóa',
  'trackingPage.deleteFailed': 'Xóa thất bại',
  'trackingPage.fetchFailed': 'Không tải được danh sách trang theo dõi',
  'trackingPage.statsFailed': 'Không tải được số liệu',
  'trackingPage.campaignStatsFailed': 'Không tải được số liệu campaign',
  'trackingPage.usersFailed': 'Không tải được danh sách người đăng ký',
  'trackingPage.form.addTitle': 'Thêm trang theo dõi',
  'trackingPage.form.editTitle': 'Sửa trang theo dõi',
  'trackingPage.form.pageLabel': 'Trang',
  'trackingPage.form.pageHint': 'So khớp với users.initial_user_page, mà field đó giờ lưu cả domain — ví dụ https://www.strongbody.ai/creators. Query string, tiền tố ngôn ngữ và id động đều bị bỏ, nên /voice/86535/earn được lưu thành /voice/earn.',
  'trackingPage.form.pageRequired': 'Bắt buộc nhập trang',
  'trackingPage.form.matchHint': 'exact = trùng đúng giá trị; prefix = mọi giá trị bắt đầu bằng nó (gộp "/creators?utm=fb", "/creators/...").',
  'trackingPage.form.labelHint': 'Tên hiển thị trong báo cáo. Bỏ trống thì dùng chính đường dẫn.',

  // Appointment requests - lead khách gửi từ trang chi tiết dịch vụ.
  'longevity_consult.title': 'Tư vấn Longevity',
  'longevity_consult.create_title': 'Thêm yêu cầu tư vấn',
  'longevity_consult.edit_title': 'Yêu cầu tư vấn',
  'longevity_consult.total': 'Tổng số yêu cầu',
  'longevity_consult.submitted_at': 'Thời gian gửi',
  'longevity_consult.contact': 'Liên hệ',
  'longevity_consult.full_name': 'Họ tên',
  'longevity_consult.country': 'Quốc gia (mã ISO)',
  'longevity_consult.phone': 'Điện thoại / WhatsApp',
  'longevity_consult.package': 'Gói',
  'longevity_consult.package_starter': 'Starter',
  'longevity_consult.package_active': 'Active',
  'longevity_consult.package_longevity': 'Longevity',
  'longevity_consult.preferred_time': 'Thời gian muốn gọi',
  'longevity_consult.preferred_date': 'Ngày muốn gọi',
  'longevity_consult.preferred_slot': 'Khung giờ',
  'longevity_consult.time_zone': 'Múi giờ',
  'longevity_consult.slot_morning': 'Sáng (8–12)',
  'longevity_consult.slot_afternoon': 'Chiều (12–17)',
  'longevity_consult.slot_evening': 'Tối (17–20)',
  'longevity_consult.answers': 'Câu trả lời',
  'longevity_consult.companion_mode': 'Mức đồng hành',
  'longevity_consult.mode_close': 'Đồng hành sát',
  'longevity_consult.mode_autonomy': 'Tự chủ cao',
  'longevity_consult.mode_unsure': 'Chưa chắc',
  'longevity_consult.focus_areas': 'Muốn tập trung vào',
  'longevity_consult.focus_sleep': 'Giấc ngủ',
  'longevity_consult.focus_energy': 'Năng lượng',
  'longevity_consult.focus_movement': 'Vận động',
  'longevity_consult.focus_nutrition': 'Dinh dưỡng',
  'longevity_consult.focus_stress': 'Căng thẳng',
  'longevity_consult.note': 'Lời nhắn của khách',
  'longevity_consult.admin_note': 'Ghi chú nội bộ',
  'longevity_consult.admin_note_placeholder': 'Kết quả gọi, bước tiếp theo… (chỉ nội bộ)',
  'longevity_consult.user': 'Tài khoản',
  'longevity_consult.guest': 'Khách vãng lai',
  'longevity_consult.locale': 'Ngôn ngữ',
  'longevity_consult.source_url': 'Trang gửi',
  'longevity_consult.status_new': 'Mới',
  'longevity_consult.status_contacted': 'Đã liên hệ',
  'longevity_consult.status_scheduled': 'Đã hẹn lịch',
  'longevity_consult.status_closed': 'Đã đóng',
  'longevity_consult.all_packages': 'Tất cả gói',
  'longevity_consult.all_statuses': 'Tất cả trạng thái',
  'longevity_consult.search_placeholder': 'Tìm #ID, tên, email, SĐT, lời nhắn',
  'longevity_consult.required': 'Bắt buộc nhập',
  'longevity_consult.invalid_email': 'Email không hợp lệ',
  'longevity_consult.invalid_country': 'Nhập mã quốc gia 2 chữ, vd VN',
  'longevity_consult.phone_code': 'Mã vùng',
  'longevity_consult.invalid_phone': 'Số điện thoại chưa hợp lệ với mã vùng đã chọn',
  'longevity_consult.load_error': 'Không tải được danh sách yêu cầu tư vấn',
  'longevity_consult.save_error': 'Không lưu được yêu cầu tư vấn',
  'longevity_consult.delete_error': 'Không xoá được yêu cầu tư vấn',
  'longevity_consult.created': 'Đã tạo yêu cầu tư vấn',
  'longevity_consult.updated': 'Đã cập nhật yêu cầu tư vấn',
  'longevity_consult.status_updated': 'Đã cập nhật trạng thái',
  'longevity_consult.deleted': 'Đã xoá yêu cầu tư vấn',
  'longevity_consult.delete_confirm': 'Xoá yêu cầu tư vấn này?',
  'appointment_request.title': 'Yêu cầu đặt hẹn',
  'appointment_request.detail_title': 'Chi tiết yêu cầu đặt hẹn',
  'appointment_request.total': 'Tổng số yêu cầu',
  'appointment_request.submitted_at': 'Thời điểm gửi',
  'appointment_request.buyer': 'Khách',
  'appointment_request.guest': 'Khách vãng lai',
  'appointment_request.registered_buyer': 'Đã có tài khoản',
  'appointment_request.organization': 'Tổ chức',
  'appointment_request.budget': 'Ngân sách',
  'appointment_request.insurance': 'Bảo hiểm',
  'appointment_request.timeframe': 'Thời gian mong muốn',
  'appointment_request.notes': 'Ghi chú',
  'appointment_request.contact_preference': 'Cách liên hệ',
  'appointment_request.all_categories': 'Tất cả danh mục',
  'appointment_request.all_statuses': 'Tất cả trạng thái',
  'appointment_request.search_placeholder': 'Tìm theo tên, email hoặc số điện thoại',
  'appointment_request.status_new': 'Mới',
  'appointment_request.status_contacted': 'Đã liên hệ',
  'appointment_request.status_closed': 'Đã đóng',
  'appointment_request.status_updated': 'Đã cập nhật trạng thái',
  'appointment_request.status_update_error': 'Không cập nhật được trạng thái',
  'appointment_request.load_error': 'Không tải được danh sách yêu cầu',
  'appointment_request.budget_flexible': 'Chọn phương án tốt nhất',
  'appointment_request.budget_capped': 'Có giới hạn',
  'appointment_request.insurance_none': 'Không có bảo hiểm',
  'appointment_request.insurance_insured': 'Có bảo hiểm',
  'appointment_request.timeframe_researching': 'Mới tìm hiểu',
  'appointment_request.timeframe_few_months': 'Trong vài tháng tới',
  'appointment_request.timeframe_local': 'Tại chỗ / sớm',
  'appointment_request.timeframe_date_range': 'Khoảng ngày cụ thể',
  'appointment_request.timeframe_asap': 'Sớm nhất có thể',
  'appointment_request.timeframe_within_3_months': 'Trong 3 tháng tới',
  'appointment_request.timeframe_specific_date': 'Ngày cụ thể',
  'appointment_request.timeframe_not_sure': 'Chưa chắc chắn',
  'appointment_request.contact_phone_email': 'Điện thoại & email',
  'appointment_request.contact_email_only': 'Chỉ email',
  'appointment_request.contact_other': 'Khác',
  'appointment_request.contact_email': 'Email',
  'appointment_request.contact_whatsapp': 'WhatsApp',
  'appointment_request.contact_phone_call': 'Gọi điện',
  'appointment_request.preferred_language': 'Ngôn ngữ mong muốn',
  'appointment_request.section_timing': 'Thời gian mong muốn',
  'appointment_request.section_contact': 'Thông tin liên hệ',
  'appointment_request.section_legacy': 'Câu trả lời ở form cũ',
  'appointment_request.full_name': 'Họ và tên',
  'appointment_request.whatsapp_number': 'Số WhatsApp',
  'appointment_request.no_preference': 'Không yêu cầu',
  'appointment_request.message': 'Lời nhắn',
  'appointment_request.type': 'Loại',
  'appointment_request.all_types': 'Tất cả loại',
  'appointment_request.type_appointment': 'Đặt hẹn',
  'appointment_request.type_intro_call': 'Gọi giới thiệu',
  'appointment_request.seller': 'Người bán',
  'appointment_request.service_or_seller': 'Dịch vụ / người bán',
  // Pro Referral (campaign 64): nhận Pro Provider miễn phí qua 20 người mời giao dịch
  'pro_referral.menu': 'Pro Referral',
  'pro_referral.title': 'Pro Referral — nhận Pro miễn phí',
  'pro_referral.info_message': 'Provider mời {goal} người dùng mới bằng mã của campaign 64; mỗi người phải có ít nhất 1 giao dịch trả tiền thành công (dịch vụ phải Hoàn tất) trong thời hạn tham gia.',
  'pro_referral.info_description': 'Đủ mục tiêu → yêu cầu vào tab <b>Chờ duyệt</b>. Duyệt sẽ cấp gói Pro Provider (ID 36) 12 tháng, 0đ, không tự gia hạn. Thời hạn tham gia, ngày mở/đóng và bật/tắt chương trình chỉnh ở <link>Affiliate campaign</link> (campaign #64, trường Duration).',
  'pro_referral.load_list_error': 'Không tải được danh sách Pro Referral',
  'pro_referral.tab_all': 'Tất cả',
  'pro_referral.hint_pending_review': 'Provider đã đủ người mua thành công trong hạn. Kiểm tra danh sách người được mời rồi Duyệt (cấp Pro Provider 12 tháng miễn phí) hoặc Từ chối (bắt buộc ghi lý do, provider sẽ thấy).',
  'pro_referral.hint_in_progress': 'Đang trong thời hạn tham gia, chưa đủ mục tiêu.',
  'pro_referral.hint_rewarded': 'Đã duyệt và đã cấp gói Pro Provider.',
  'pro_referral.hint_rejected': 'Đã từ chối yêu cầu.',
  'pro_referral.hint_expired': 'Quá hạn chót mà chưa đủ mục tiêu.',
  'pro_referral.hint_superseded': 'Provider tự mua Pro trước khi đạt mục tiêu — thử thách đóng.',
  'pro_referral.hint_all': 'Tất cả người tham gia campaign 64.',
  'pro_referral.search_placeholder': 'Tên, email, user id, mã mời',
  'pro_referral.no_name': '(chưa có tên)',
  'pro_referral.user_code': 'user #{id} · mã {code}',
  'pro_referral.col_provider': 'Provider',
  'pro_referral.col_progress': 'Tiến độ',
  'pro_referral.col_joined': 'Tham gia',
  'pro_referral.col_deadline': 'Hạn chót',
  'pro_referral.col_goal_reached': 'Đạt mục tiêu',
  'pro_referral.col_status': 'Trạng thái',
  'pro_referral.col_actions': 'Thao tác',
  'pro_referral.purchased': 'đã mua',
  'pro_referral.invited_count': 'Đã mời {count}',
  'pro_referral.pending_count': ' · chờ hoàn tất {count}',
  'pro_referral.btn_review': 'Xét duyệt',
  'pro_referral.btn_detail': 'Chi tiết',
  'pro_referral.total_participants': '{count} người tham gia',
  'pro_referral.total_invitees': '{count} người',
  'pro_referral.status_pending_review': 'Chờ duyệt',
  'pro_referral.status_in_progress': 'Đang diễn ra',
  'pro_referral.status_rewarded': 'Đã duyệt · nhận Pro',
  'pro_referral.status_rejected': 'Từ chối',
  'pro_referral.status_expired': 'Hết hạn',
  'pro_referral.status_superseded': 'Đã có Pro (tự mua)',
  'pro_referral.invitee_qualified': 'Đã mua',
  'pro_referral.invitee_pending': 'Chờ hoàn tất đơn',
  'pro_referral.invitee_registered': 'Đã đăng ký',
  'pro_referral.txn_service': 'Dịch vụ / booking',
  'pro_referral.txn_product': 'Sản phẩm',
  'pro_referral.txn_subscription': 'Gói subscription',
  'pro_referral.txn_credit': 'Credit',
  'pro_referral.ref_service': 'Offer',
  'pro_referral.ref_product': 'Order',
  'pro_referral.ref_subscription': 'User subscription',
  'pro_referral.ref_credit': 'Credit purchase',
  'pro_referral.claim_pending': 'Chờ duyệt',
  'pro_referral.claim_approved': 'Đã duyệt',
  'pro_referral.claim_rejected': 'Đã từ chối',
  'pro_referral.load_detail_error': 'Không tải được thông tin người tham gia',
  'pro_referral.load_invitees_error': 'Không tải được danh sách người được mời',
  'pro_referral.approve_success': 'Đã duyệt — đã cấp gói Pro Provider',
  'pro_referral.reject_success': 'Đã từ chối yêu cầu',
  'pro_referral.action_error': 'Thao tác không thành công',
  'pro_referral.view_only': 'Yêu cầu đang chờ duyệt. Chỉ Super, Admin hoặc Lead Operation được duyệt / từ chối.',
  'pro_referral.active_pro_warning': 'Provider đang có gói Pro còn hạn đến {date} (plan #{plan}, {provider}).',
  'pro_referral.active_pro_warning_desc': 'Nếu duyệt, gói tặng 12 tháng sẽ bắt đầu nối tiếp sau ngày hết hạn này.',
  'pro_referral.field_provider': 'Provider',
  'pro_referral.field_user_code': 'User ID / mã mời',
  'pro_referral.field_status': 'Trạng thái',
  'pro_referral.field_progress': 'Tiến độ',
  'pro_referral.progress_detail': 'đã mua · đã mời {invited}',
  'pro_referral.field_joined': 'Tham gia',
  'pro_referral.field_deadline': 'Hạn chót',
  'pro_referral.window_days': '({days} ngày)',
  'pro_referral.days_left': ' · còn {days} ngày',
  'pro_referral.field_goal_reached': 'Đạt mục tiêu lúc',
  'pro_referral.section_claim': 'Yêu cầu nhận Pro',
  'pro_referral.field_claim_status': 'Trạng thái yêu cầu',
  'pro_referral.field_qualified_count': 'Số người đạt chuẩn khi gửi',
  'pro_referral.field_reviewer': 'Người duyệt',
  'pro_referral.field_reviewed_at': 'Thời điểm',
  'pro_referral.field_reject_reason': 'Lý do từ chối',
  'pro_referral.field_note': 'Ghi chú',
  'pro_referral.field_granted_plan': 'Gói đã cấp',
  'pro_referral.granted_plan_value': 'User subscription #{id} · {start} → {end}',
  'pro_referral.section_invitees': 'Người được mời ({count})',
  'pro_referral.invitees_hint': 'Chỉ tính tài khoản mới đăng ký bằng mã mời trước hạn chót. "Giao dịch được tính" là giao dịch hợp lệ đầu tiên — kiểm tra trước khi duyệt (vd. nhiều tài khoản cùng mua dịch vụ của chính provider).',
  'pro_referral.col_invitee': 'Người được mời',
  'pro_referral.col_signup': 'Đăng ký',
  'pro_referral.col_counted_txn': 'Giao dịch được tính',
  'pro_referral.btn_reject': 'Từ chối',
  'pro_referral.btn_approve': 'Duyệt & cấp Pro',
  'pro_referral.cancel': 'Huỷ',
  'pro_referral.approve_title': 'Duyệt yêu cầu & cấp gói Pro Provider',
  'pro_referral.reject_title': 'Từ chối yêu cầu',
  'pro_referral.approve_body': 'Cấp gói <b>Pro Provider (ID 36)</b> 12 tháng, 0đ, không tự gia hạn cho <b>{name}</b>. Provider nhận thông báo ngay. Thao tác không hoàn tác được.',
  'pro_referral.note_label': 'Ghi chú nội bộ (tuỳ chọn)',
  'pro_referral.reject_body': 'Provider sẽ nhận thông báo kèm lý do (viết bằng tiếng Anh) và không thể gửi lại yêu cầu.',
  'pro_referral.reason_label': 'Lý do từ chối',
  'pro_referral.reason_required': 'Nhập lý do từ chối',
  'pro_referral.reason_min': 'Lý do tối thiểu 5 ký tự',
  'pro_referral.reason_placeholder': 'VD: Several invited accounts look like fake accounts.',
};
